jQuery(document).ready(function($){

	/*
        How to tell if a DOM element is visible in the current viewport?
        http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
    */
	function elementInViewport(el) {
		var top = el.offsetTop;
		var left = el.offsetLeft;
		var width = el.offsetWidth;
		var height = el.offsetHeight;

		while(el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}

		return (
			top < (window.pageYOffset + window.innerHeight) &&
			left < (window.pageXOffset + window.innerWidth) &&
			(top + height) > window.pageYOffset &&
			(left + width) > window.pageXOffset
		);
	}
});

// Touch Up Slider

(function($) {

	$(document).ready(function() {
		var pdpDifference = document.querySelector('.difference-block-mobile');

		if (pdpDifference) {
			$(pdpDifference).each(function() {
				var slider = this.querySelector('.slick-track');
				var cardContainer = $('.difference-mobile').outerWidth();

				$(slider).add().css("left", -cardContainer);

			});
		}

	})

})(jQuery);

// Quantity Buttons Implementation

(function($) {

	qty_buttons()

	function qty_buttons() {
		let form = $('body').find('form.cart'),
			minus = document.querySelector('.minus'),
			plus = document.querySelector('.plus'),
			qty_el = $('.quantity'),
			qty_input = $(qty_el).find('.quantity input.qty')

		if ($('body').find('.single-prod-wrapper .single-prod').hasClass('sample-pack')) {
			$(qty_input).each(function() {
				$(this).attr('max', '1')
			})
		}

	}

	// from OLD CODE base
	if (!String.prototype.getDecimals) {
		String.prototype.getDecimals = function () {
			var num = this,
				match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
			if (!match) {
				return 0;
			}
			return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
		}
	}
	// Quantity "plus" and "minus" buttons
	$(document.body).on('click', '.plus, .minus', function () {
		var $qty = $(this).closest('.quantity').find('.qty'),
			currentVal = parseFloat($qty.val()),
			max = parseFloat($qty.attr('max')),
			min = parseFloat($qty.attr('min')),
			step = $qty.attr('step'),
			prod_price_el = $('.product-type-mix-and-match .single-prod-summary .prod-price'),
			error_msg = $(this).parent().find('.wc_mnm_child_item_error');

		// Format values
		if (!currentVal || currentVal === '' || currentVal === 'NaN')
			currentVal = 0;
		if (max === '' || max === 'NaN')
			max = '';
		if (min === '' || min === 'NaN')
			min = 0;
		if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN')
			step = 1;


		// Change the value
		if ($(this).is('.plus')) {

			if (parseInt($(this).prev().val()) === 1) {

				if ($('body').find('.single-prod-wrapper').hasClass('post-12802')) {
					if (error_msg.length) {
						$(error_msg).text('Maximum 1 per Order')
						$(error_msg).addClass('show')
					} else {
						//$(this).parent().append('<div class="wc_mnm_child_item_error" aria-live="polite" style="visibility: visible"><span>Maximum 1 per Order</span></div>');
					}
				}
			}

			if (max && (currentVal >= max)) {
				$qty.val(max);
			} else {
				$qty.val((currentVal + parseFloat(step)).toFixed(step.getDecimals()));
			}

		} else {
			if (min && (currentVal <= min)) {
				$qty.val(min);
			} else if (currentVal > 0) {
				$qty.val((currentVal - parseFloat(step)).toFixed(step.getDecimals()));
			}
		}

		// Trigger change event
		$qty.trigger('change');

	});


})(jQuery);

// Slider.js functionality

(function($) {

	// Slider.js
	$('.carousel-block .slides').slick({
		dots: false,
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: true,
	});

	$('.feedback-block .slider-container-mobile').slick({
		dots: true,
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
	});

	$('.home-carousel-container').slick({
		dots: true,
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
	});

	$('.product-slider-block .slides').slick({
		variableWidth: true,
		dots: false,
		infinite: true,
		arrows: true,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 2,
					loop: false,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					loop: false,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.product-category-slider-block .slides').slick({
		variableWidth: true,
		dots: false,
		infinite: true,
		arrows: false,
		autoplay: true,
		loop: true,
		autoplaySpeed: 1000,
		speed: 2200,
		delay: 3250,
		slidesToShow: 3,
		slidesToScroll: 3,
		pauseOnFocus: false,
		pauseOnSwipe: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					centerMode: true,
					centerPadding: '0',
					delay: 1000,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.logo-container .slides').slick({
		dots: false,
		infinite: true,
		variableWidth: true,
		speed: 1000,
		slidesToShow: 6,
		slidesToScroll: 9,
		autoplay: false,
		arrows: true,
	});

	$('.product-carousel-container .product-carousel').slick({
		dots: false,
		infinite: true,
		speed: 1000,
		loop: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
	});

	$('.relevancy-block-mobile .slider-container').slick({
		centerMode: true,
		centerPadding: '0',
		variableWidth: true,
		dots: false,
		infinite: true,
		arrows: true,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 2,
					loop: true,
					slidesToScroll: 1
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});

	$('.relevancy-block-mobile .slider-container-mobile').slick({
		centerPadding: '0',
		variableWidth: true,
		dots: false,
		infinite: true,
		arrows: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 2,
					loop: true,
					slidesToScroll: 1
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});

	$('.difference-block-mobile .standard-difference-mobile').slick({
		centerMode: true,
		centerPadding: '0',
		variableWidth: true,
		dots: false,
		infinite: true,
		arrows: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 2,
					loop: true,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.difference-block-mobile .pen-difference-mobile').slick({
		centerMode: true,
		centerPadding: '0',
		variableWidth: true,
		dots: false,
		infinite: true,
		arrows: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 2,
					loop: true,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.difference-block-mobile .aerosol-difference-mobile').slick({
		centerMode: true,
		centerPadding: '0',
		variableWidth: true,
		dots: false,
		infinite: true,
		arrows: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 2,
					loop: true,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.difference-block-mobile .bottle-difference-mobile').slick({
		centerMode: true,
		centerPadding: '0',
		variableWidth: true,
		dots: false,
		infinite: true,
		arrows: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 2,
					loop: true,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.difference-block-mobile .tins-difference-mobile').slick({
		centerMode: true,
		centerPadding: '0',
		variableWidth: true,
		dots: false,
		infinite: true,
		arrows: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 2,
					loop: true,
					slidesToScroll: 1
				}
			}
		]
	});

})(jQuery)

// Slider.js arrows inject

function changeSlickArrows() {

	if (document.querySelectorAll('.slick-next.slick-arrow')) {
		document.querySelectorAll('.slick-next.slick-arrow').forEach(next => {
			next.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 5l7 7-7 7"></path> </g></svg>';
		});
	}

	if (document.querySelectorAll('.slick-prev.slick-arrow')) {
		document.querySelectorAll('.slick-prev.slick-arrow').forEach(prev => {
			prev.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l-7 7 7 7"></path> </g></svg>';
		});
	}

}

changeSlickArrows();

// Thank you plus and minus

function changeThankyouIcons() {

	if (document.querySelectorAll('.woocommerce-order-received .cuw-plus')) {
		document.querySelectorAll('.woocommerce-order-received .cuw-plus').forEach(plus => {
			plus.innerHTML = '<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.72 26.72"><defs></defs><g id="Layer_1-2"><path d="m14.93,11.79h11.79v3.15h-11.79v11.79h-3.15v-11.79H0v-3.15h11.79V0h3.15v11.79Z"/></g></svg>';
		});
	}

	if (document.querySelectorAll('.woocommerce-order-received .cuw-minus')) {
		document.querySelectorAll('.woocommerce-order-received .cuw-minus').forEach(minus => {
			minus.innerHTML = '<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.2 3.46"><defs></defs><g id="Layer_1-2"><path d="m26.2,3.46H0V0h26.2v3.46Z"/></g></svg>';
		});
	}

}

changeThankyouIcons();

// Arrow mobile menu

function changeMenuArrows() {
	var searchOriginal = document.querySelector('.header-menu-end .header-menu-search');
	var searchHTML = searchOriginal.outerHTML;

	if (document.querySelectorAll('.mega-toggle-blocks-left')) {
		document.querySelectorAll('.mega-toggle-blocks-left').forEach(search => {
			search.innerHTML = searchHTML;
		});
	}

	if (document.querySelectorAll('.mega-indicator')) {
		document.querySelectorAll('.mega-indicator').forEach(arrow => {
			arrow.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 5l7 7-7 7"></path> </g></svg>';
		});
	}

}

changeMenuArrows();

function changeBlogPagination() {
	var blogOriginal = document.querySelector('.post-type-archive-blog');
	const listItem = document.createElement("li");

	if (blogOriginal) {
		if (document.querySelectorAll('.blog-pagination .page-numbers')) {
			document.querySelectorAll('.blog-pagination .page-numbers').forEach(pagination => {
				pagination.classList.remove('page-numbers');
				pagination.classList.add('page-link');
				$html = pagination.outerHTML;
				console.log($html);
				new_html = "<li class='page-item'>" + $html + "</li>";
				pagination.outerHTML = new_html;
			});
		}

		if (document.querySelectorAll('.blog-pagination .current')) {
			document.querySelectorAll('.blog-pagination .current').forEach(current => {
				current.classList.remove('current');
				current.parentElement.classList.add('active');
			});
		}
	}
}

changeBlogPagination();

function showSearchBar() {
	var navbar = document.querySelector('#wrapper-navbar');
	var searchButtonNav = navbar.querySelector('.header-menu-search');
	var searchButtonMB = navbar.querySelector('.search-mb');
	var searchMenu = navbar.querySelector('.search-form-wrapper');
	var searchClose = navbar.querySelector('.btn-search-clear');

	if (searchButtonNav) {
		document.querySelectorAll('.header-menu-search').forEach(arrow => {
			arrow.addEventListener('click', function(e) {
				e.preventDefault();
				searchMenu.classList.toggle('active');
				document.body.style.overflow = 'hidden';
			});
		});
	}

	if (searchButtonMB) {
		searchButtonMB.addEventListener('click', function() {
			searchMenu.classList.toggle('active');
		});
	}



	if (searchClose) {
		searchClose.addEventListener('click', function() {
			searchMenu.classList.toggle('active');
			document.body.style.overflow = 'auto';
		});
	}

}
showSearchBar();

// Menu functionality
function mobileIcon () {
	var navbar = document.querySelector('#wrapper-navbar');
	var menuOpen = document.querySelector('.header-menu-end');
	var barDiv = navbar.querySelector('.menu-mobile');

	var promise = document.querySelector('.header-promise-container');
	var logoCustom = document.querySelector('.custom-logo-link');


	if (barDiv) {
		barDiv.addEventListener('click', function() {
			barDiv.classList.toggle('open');
			menuOpen.classList.toggle('menu-open');

			promise.classList.toggle('d-none');
			logoCustom.classList.toggle('d-none');

			if (barDiv.classList.contains('open')) {
				// Menu is open, disable scrolling
				document.body.style.overflow = 'hidden';
				document.querySelector('#menu-icon').classList.add('fa-times');
				document.querySelector('#menu-icon').classList.remove('fa-bars');

				document.querySelector('#menu-search').classList.remove('d-none');
				document.querySelector('#menu-search').classList.add('d-flex');

				document.querySelector('#menu-cart').classList.add('d-none');


			} else {
				// Menu is closed, enable scrolling
				document.body.style.overflow = 'auto';
				document.querySelector('#menu-icon').classList.remove('fa-times');
				document.querySelector('#menu-icon').classList.add('fa-bars');

				document.querySelector('#menu-search').classList.add('d-none');
				document.querySelector('#menu-search').classList.remove('d-flex');

				document.querySelector('#menu-cart').classList.remove('d-none');
			}
		});
	}
}
mobileIcon();

// Before & After Slider Functionality

(function($) {

	let sliderContainer = $('body').find('.before-after-container')

	if (sliderContainer) {
		$('.slider-image').each(function(){
			const $this = $(this);
			var slide = $this.find('.slider');
			var image = $this.find('.foreground-img');
			var thumb = $this.find('.slider-button');
			var isMobile = window.innerWidth < 768;

			slide.on('input change', (e) => {
				const sliderPos = e.target.value;

				$(image).css('width', `${sliderPos}%`);

				if (isMobile) {
					$(thumb).css('left', `calc(${sliderPos}% - 20px)`);
				} else {
					$(thumb).css('left', `calc(${sliderPos}% - 18px)`);
				}
			});
		});
	}

})(jQuery);

// Product Carousel

(function($) {

	$(document).ready(function() {

		$('.image-container').on('click', function() {

			var activeImage = this.querySelector('.img-item');
			var activeImageHTML = activeImage.outerHTML;

			var activeImageContainer = document.querySelector('.img-product-container');
			var existingActiveImage = document.querySelector('.img-product');

			// Removing active image to make place for the image selected from carousel
			if (existingActiveImage) {
				existingActiveImage.remove();
			}

			// Adding carousel image into the missing active image position
			activeImageContainer.innerHTML = activeImageHTML

			// Removing and ammending the class of the carousel to be the active image class
			var removeChildClass = document.querySelector('.img-product-container .img-item');

			if (removeChildClass) {
				removeChildClass.classList.remove('img-item');
				removeChildClass.classList.add('img-product');
			}

		});
	})

})(jQuery);

// PPC Image Carousel

(function($) {

	$(document).ready(function() {

		var featured = document.querySelector('.ppc-featured-image');
		var ppcCarousel = document.querySelector('.ppc-preview-content');

		if (featured && ppcCarousel) {
			var getFeatured = featured.innerHTML;
			var featuredContainer = '<div class="col-3 px-1 px-lg-2 ppc-preview">' + getFeatured + '</div>'

			$(ppcCarousel).prepend(featuredContainer);

			$('.ppc-preview').on('click', function() {

				var removeExistingFeatured = ppcCarousel.querySelector('.featured');

				if (removeExistingFeatured) {
					removeExistingFeatured.classList.remove('featured');
				}

				var addFeatured = this.querySelector('.ppc-image');

				addFeatured.classList.add('featured');

				var previewImageHTML = this.innerHTML;

				var featuredImageContainer = document.querySelector('.ppc-featured-image');
				var existingFeaturedImage = featuredImageContainer.querySelector('.featured');

				// Removing active image to make place for the image selected from carousel
				if (existingFeaturedImage) {
					existingFeaturedImage.remove();
				}

				// Adding carousel image into the missing active image position
				featuredImageContainer.innerHTML = previewImageHTML;

			});
		}
	})

})(jQuery);

// Fly cart adaption

(function($) {

	let flyoutShow = $('body').find('.woofc-show')

	if (flyoutShow) {
		$(document).keydown(function(e) {
			// ESCAPE key pressed
			if (e.keyCode == 27) {
				document.querySelector('body').classList.remove('woofc-show');
			}
		});
	}


})(jQuery);

// Injecting AJAX List

(function($) {

	var ROP = document.querySelector('.search-pan-ral-colour-container');
	var filter = document.querySelector('.filter-container');
	var heroSearch = document.querySelector('.hero-search');

	if (ROP) {
		$('.search-pan-ral-colour-container').each(function () {
			const $this = $(this);
			var selectColourType = $this.find('.pan-ral-colour-select');
			var inputROPColorCode = $this.find('.color-input');
			var searchColourButton = $this.find('.pan-ral-order-now');
			var findAllButton = $this.find('.pan-ral-all');
			var paintPrefix = document.querySelector('.paint-prefix');

			function constructROPURL () {
				var baseUrl = window.site.url;
				var colour = paintPrefix.innerHTML;
				var colourType = selectColourType.val();

				var url = baseUrl + colour + '/' + colourType + '/' + 'all/';
				return url;
			}

			selectColourType.on('change', function() {
				findAllButton.removeClass('disabled');
				var url = constructROPURL();
				findAllButton.append().attr('href', url);

				if(inputROPColorCode) {
					inputROPColorCode.val('');
					inputROPColorCode.removeClass('disabled');
					searchColourButton.addClass('disabled');
					searchColourButton.append().attr('href', '#');
				}
			});

			// Colour Code Input Change

			function colorCodeROPURL () {
				var baseUrl = window.site.url;
				var vehicle = paintPrefix.innerHTML;
				var color = inputROPColorCode.val();
				var colourType = selectColourType.val();

				// If user hasn't chosen a colour type or entered a color, return '#'
				if (!colourType || !color) {
					return '#';
				}

				// Construct the new URL:
				return baseUrl + vehicle + '/' + encodeURIComponent(colourType) + '/all/?paint_search=' + encodeURIComponent(color);
			}

			inputROPColorCode.on('input propertychange', function() {
				if(inputROPColorCode.val()) {

					searchColourButton.removeClass('disabled');
					var url = colorCodeROPURL();
					searchColourButton.append().attr('href', url);
				}
			});

			inputROPColorCode.keypress(function (e) {
				var key = e.which;
				if(key == 13)  // the enter key code
				{
					if(inputROPColorCode.val()) {
						window.location = colorCodeROPURL();
					}

					return false;
				}
			});
		});
	}

	if (filter) {
		$('.filter-container').each(function () {
			const $this = $(this);
			var selectElementYear = $this.find('.year-filter');
			var enableYear = $this.find('.year-filter-container.disabled');
			var loader = $this.find('.loading-container');

			if(selectElementYear) {
				function populateYearsFilter() {

					var searched = window.location.href.indexOf("?year");

					var yearUrl = $(location).attr('href'),
						spliturl = yearUrl.split("/"),
						yearQuery = spliturl[spliturl.length-1],
						isYear = yearQuery.split("?year=");

					// selectElementYear.children().val;

					if (searched > -1) {
						// console.log(isYear);
						// selectElementYear.children().val.has(isYear).addClass("Test");
					}


					enableYear.removeClass('disabled');
					loader.hide();
				}

				populateYearsFilter();

				function constructURL () {
					var baseUrl = window.location.pathname;
					var year = selectElementYear.val();
					var url = baseUrl + '/?year=' + year;
					return url;
				}

				selectElementYear.on('change', function() {
					var url = constructURL();
					window.location.href = url;
				});
			} else {
				loader.hide();
			}
		});
	}

	if (heroSearch) {
		$('.hero-search').each(function () {
			const $this = $(this);
			var selectElementVehicle = document.querySelectorAll('.radio-selection');
			var selectElementYear = $this.find('.year-select');
			var selectElementManufacturer = $this.find('.brand-select');
			var selectElementModel = $this.find('.model-select');
			var inputElementColorCode = $this.find('.color-code-input');
			var inputElementReg = $this.find('.reg-input');
			var enableYear = $this.find('.year-select-container.disabled');
			var enableManufacturer = $this.find('.brand-select-container.disabled');
			var enableModel = $this.find('.model-select-container.disabled');
			var enableColor = $this.find('.color-input-container.disabled');
			var disableYear = $this.find('.year-select-container');
			var disableManufacturer = $this.find('.brand-select-container');
			var disableModel = $this.find('.model-select-container');
			var disableColor = $this.find('.color-input-container');
			var loader = $this.find('.loading-container');
			var searchButton = $this.find('.colour-search');
			var searchRegButton = $this.find('.btn-reg-search');
			var paintPrefix = document.querySelector('.paint-prefix');

			var yearSelectionContainer = $this.find('.year-selection-container');
			var brandSelectionContainer = $this.find('.brand-selection-container');
			var modelSelectionContainer = $this.find('.model-selection-container');
			var paintSelectionContainer = $this.find('.paint-selection-container');

			var regSelectionContainer = $this.find('.reg-selection-container');
			var regLabel = $this.find(".reg-number");
			var modelLabel = $this.find(".make-model");
			var codeLabel = $this.find(".colour-code");
			var ropLabel = $this.find(".colourROP");

			var hideCodeSearchContainer = $this.find('.color-code-selection-container');
			var colourCodeSearch = $this.find('.search-colour-code');
			var paintSearchContainer = $this.find('.search-paint-colour');
			var colourAllContainer = $this.find('.search-pan-ral-all');
			var colourAllButton = $this.find('.pan-ral-all');
			var selectColourContainer = $this.find('.paint-select-container');
			var selectColourType = $this.find('.paint-select');
			var ropColourSearch = $this.find('.rop-colour-input');
			var penCookie = document.querySelector('.pen-search');
			var tinsCookie = document.querySelector('.tins-search');
			var aerosolCookie = document.querySelector('.aerosol-search');
			var bottleCookie = document.querySelector('.bottle-search');
			var headerSticky = document.querySelector('.header-sticky');

			// Populate All except Colour
			function populateYears(vehicleSlug) {
				if (vehicleSlug === 'car') {
					vehicleSlug = 'car,motorbike';
				}

				$.ajax({
					type: "GET",
					url: window.site.url + '/wp-json/db-dropdowns/v3/years/' + vehicleSlug + '/',
					success: function(data){
						// when cached, data is returned as content type text/html
						// jquery doesn't parse this as json, so we do it manually here
						// in order to cache, our endpoints should have trailing slashes
						if(typeof data == 'string') data = JSON.parse(data)

						for (var i = 0; i < data.length; i++) {
							var option = $('<option>').addClass('option').attr('value', data[i].slug).text(data[i].name);
							selectElementYear.append(option);
						}

						enableYear.removeClass('disabled');
						loader.hide();
					}
				});
			}

			function populateManufacturers(vehicleSlug, yearSlug) {
				if (vehicleSlug === 'car') {
					vehicleSlug = 'car,motorbike';
				}

				$.ajax({
					type: "GET",
					url: window.site.url + '/wp-json/db-dropdowns/v3/manufacturers/' + yearSlug + '/' + vehicleSlug + '/',
					success: function(data){

						console.log(data);

						if(typeof data == 'string') data = JSON.parse(data)

						for (var i = 0; i < data.length; i++) {
							var option = $('<option>').addClass('option').attr('value', data[i].slug).text(data[i].name);
							selectElementManufacturer.append(option);
						}

						enableManufacturer.removeClass('disabled');
						loader.hide();
					}
				});
			}

			function populateModels(vehicleSlug, yearSlug, manufacturerSlug) {
				if (vehicleSlug === 'car') {
					vehicleSlug = 'car,motorbike';
				}

				$.ajax({
					type: "GET",
					url: window.site.url + '/wp-json/db-dropdowns/v3/models/' + yearSlug + '/' + manufacturerSlug + '/' + vehicleSlug + '/',
					success: function(data){
						if(typeof data == 'string') data = JSON.parse(data)

						for (var i = 0; i < data.length; i++) {
							var option = $('<option>').addClass('option').attr('value', data[i].prefix + '::::' + data[i].slug).text(data[i].name);
							selectElementModel.append(option);
						}

						enableModel.removeClass('disabled');
						loader.hide();
					}
				});
			}

			$(selectElementVehicle).each(function () {

				$(this).on('change', function() {
					var selectedVehicleSlug = $(this).val();

					if (selectedVehicleSlug === 'colour') {
						ropLabel.addClass('selected');
						colourAllButton.removeClass('d-none');
						searchButton.removeClass('d-none');
						paintSelectionContainer.removeClass('d-none');
						paintSearchContainer.removeClass('d-none');
						hideCodeSearchContainer.removeClass('d-none');

						colourCodeSearch.addClass('d-none');
						yearSelectionContainer.addClass('d-none');
						brandSelectionContainer.addClass('d-none');
						modelSelectionContainer.addClass('d-none');
						regSelectionContainer.addClass('d-none');
						regLabel.removeClass('selected');
						modelLabel.removeClass('selected');
						codeLabel.removeClass('selected');

						selectColourContainer.removeClass('disabled');

						searchButton.addClass('disabled');
						colourAllButton.addClass('disabled');
						ropColourSearch.addClass('disabled');

					}

					if (selectedVehicleSlug === 'reg') {
						regLabel.addClass('selected');
						regSelectionContainer.removeClass('d-none');
						colourAllButton.addClass('d-none');
						searchButton.addClass('d-none');
						paintSelectionContainer.addClass('d-none');
						paintSearchContainer.addClass('d-none');
						hideCodeSearchContainer.addClass('d-none');
						colourCodeSearch.addClass('d-none');
						yearSelectionContainer.addClass('d-none');
						brandSelectionContainer.addClass('d-none');
						modelSelectionContainer.addClass('d-none');
						modelLabel.removeClass('selected');
						codeLabel.removeClass('selected');
						ropLabel.removeClass('selected');
					}

					if (selectedVehicleSlug === 'code') {
						codeLabel.addClass('selected');
						hideCodeSearchContainer.removeClass('d-none');
						colourCodeSearch.removeClass('d-none');
						searchButton.removeClass('d-none');

						regSelectionContainer.addClass('d-none');
						colourAllButton.addClass('d-none');
						paintSelectionContainer.addClass('d-none');
						paintSearchContainer.addClass('d-none');
						yearSelectionContainer.addClass('d-none');
						brandSelectionContainer.addClass('d-none');
						modelSelectionContainer.addClass('d-none');
						regLabel.removeClass('selected');
						modelLabel.removeClass('selected');
						ropLabel.removeClass('selected');

					}

					if (selectedVehicleSlug === 'car,motorbike') {
						loader.show();
						if (brandSelectionContainer.addClass('d-none')) {
							modelLabel.addClass('selected');
							hideCodeSearchContainer.addClass('d-none');
							colourAllButton.addClass('d-none');
							paintSelectionContainer.addClass('d-none');
							paintSearchContainer.addClass('d-none');
							regSelectionContainer.addClass('d-none');
							colourCodeSearch.addClass('d-none');

							searchButton.removeClass('d-none');
							yearSelectionContainer.removeClass('d-none');
							brandSelectionContainer.removeClass('d-none');
							modelSelectionContainer.removeClass('d-none');
							codeLabel.removeClass('selected');
							regLabel.removeClass('selected');
							ropLabel.removeClass('selected');
						}

						selectElementYear.children().not(':first').remove();
						selectElementYear.children().prop('selected', true);

						selectElementManufacturer.children().not(':first').remove();
						selectElementManufacturer.children().prop('selected', true);

						selectElementModel.children().not(':first').remove();
						selectElementModel.children().prop('selected', true);
						disableModel.addClass('disabled');
						searchButton.addClass('disabled');

						if(disableColor.hasClass('disabled')) {
							disableColor.removeClass('disabled');
						}

						populateYears(selectedVehicleSlug);
					}
				});

			});


			// Change inputs except Colour
			selectElementYear.on('change', function() {
				loader.show();

				var selectedVehicleSlug = 'car,motorbike';
				var selectedYearSlug = $(this).val();

				selectElementManufacturer.children().not(':first').remove();
				selectElementManufacturer.children().prop('selected', true);

				selectElementModel.children().not(':first').remove();
				selectElementModel.children().prop('selected', true);
				disableModel.addClass('disabled');
				searchButton.addClass('disabled');

				if(disableColor.hasClass('disabled')) {
					disableColor.removeClass('disabled');
				}

				populateManufacturers(selectedVehicleSlug, selectedYearSlug);
			});

			// Event handler for when the user selects a manufacturer
			selectElementManufacturer.on('change', function() {
				var selectedVehicleSlug = 'car,motorbike';
				var selectedYearSlug = selectElementYear.val();
				var selectedManufacturerSlug = $(this).val();

				selectElementModel.children().not(':first').remove();
				selectElementModel.children().prop('selected', true);
				searchButton.addClass('disabled');

				if(disableColor.hasClass('disabled')) {
					disableColor.removeClass('disabled');
				}

				populateModels(selectedVehicleSlug, selectedYearSlug, selectedManufacturerSlug);
				loader.show();
			});

			function constructURL () {
				var baseUrl = window.site.url;
				var year = selectElementYear.val();
				var brand = selectElementManufacturer.val();
				var model = selectElementModel.val().split('::::');
				var url = baseUrl + model[0] + '/' + brand + '/' + model[1] + '/?year=' + year;
				return url;
			}

			selectElementModel.on('change', function() {
				searchButton.removeClass('disabled');
				var url = constructURL();
				searchButton.append().attr('href', url);

				if(selectElementModel) {
					disableColor.addClass('disabled');
				} else {
					if(enableColor) {
						enableColor.removeClass('disabled');
					}
				}
			});

			// Colour Code Input Change

			function colorCodeURL () {
				var baseUrl = window.site.url;
				var color = inputElementColorCode.val();
				var url = baseUrl + "search-color" + '/?paint_search=' + color + '&paint_manufacturer=any';

				return url;
			}

			inputElementColorCode.on('input propertychange', function() {
				if(inputElementColorCode.val()) {
					if (!disableYear.hasClass('disabled')) {
						disableYear.addClass('disabled');
						selectElementYear.children().not(':first').remove();
						selectElementYear.children().prop('selected', true);
					}

					if (!disableManufacturer.hasClass('disabled')) {
						disableManufacturer.addClass('disabled');
						selectElementManufacturer.children().not(':first').remove();
						selectElementManufacturer.children().prop('selected', true);
					}

					if (!disableModel.hasClass('disabled')) {
						disableModel.addClass('disabled');
						selectElementModel.children().not(':first').remove();
					}

					searchButton.removeClass('disabled');
					var url = colorCodeURL();
					searchButton.append().attr('href', url);

					searchButton.click();

				} else {
					if(enableYear) {
						loader.show();
						var selectedVehicleSlug = selectElementVehicle.val();
						populateYears(selectedVehicleSlug);
					}

					if (!searchButton.hasClass('disabled')) {
						searchButton.addClass('disabled');
					}
				}
			});

			inputElementColorCode.keypress(function (e) {
				var key = e.which;
				if(key == 13)  // the enter key code
				{
					if(inputElementColorCode.val()) {
						window.location = colorCodeURL();
					}

					return false;
				}
			});

			// Paint URLs/event handlers

			function constructPaintURL () {
				var baseUrl = window.site.url;
				var colour = paintPrefix.innerHTML;
				var colourType = selectColourType.val();

				var url = baseUrl + colour + '/' + colourType + '/' + 'all/';
				return url;
			}

			selectColourType.on('change', function() {
				colourAllButton.removeClass('disabled');
				var url = constructPaintURL();
				colourAllButton.append().attr('href', url);

				if(ropColourSearch) {
					ropColourSearch.val('');
					searchButton.addClass('disabled');
					searchButton.append().attr('href', '#');
					ropColourSearch.removeClass('disabled');
				}
			});

			// Colour Code Input Change

			function paintURL () {
				var baseUrl = window.site.url;
				var vehicle = paintPrefix.innerHTML;

				var color = ropColourSearch.val();
				var colourType = selectColourType.val();

				// If user hasn't chosen a colour type or entered a color, return '#'
				if (!colourType || !color) {
					return '#';
				}

				// Construct the new URL:
				return baseUrl + vehicle + '/' + encodeURIComponent(colourType) + '/all/?paint_search=' + encodeURIComponent(color);
			}

			ropColourSearch.on('input propertychange', function() {
				if(ropColourSearch.val()) {

					searchButton.removeClass('disabled');
					var url = paintURL();
					searchButton.append().attr('href', url);
				}
			});

			ropColourSearch.keypress(function (e) {
				var key = e.which;
				if(key == 13)  // the enter key code
				{
					if(ropColourSearch.val()) {
						window.location = paintURL();
					}

					return false;
				}
			});

			if(inputElementReg.val()) {
				searchRegButton.removeClass('disabled');
			}

			inputElementReg.on('input propertychange', function() {
				if(inputElementReg.val()) {
					searchRegButton.removeClass('disabled');
				} else {
					if (!searchRegButton.hasClass('disabled')) {
						searchRegButton.addClass('disabled');
					}
				}
			});

			inputElementReg.keypress(function (e) {
				var key = e.which;
				if(key == 13)  // the enter key code
				{
					if(inputElementReg.val()) {
						searchRegButton.click();
					}
					return false;
				}
			});

			if (searchButton && penCookie) {
				searchButton.on('click', function() {
					sessionStorage.setItem("searched-pen", true);
				});
			}

			if (colourAllButton && penCookie) {
				colourAllButton.on('click', function() {
					sessionStorage.setItem("searched-pen", true);
				});
			}

			if (searchButton && tinsCookie) {
				searchButton.on('click', function() {
					sessionStorage.setItem("searched-tins", true);
				});
			}

			if (colourAllButton && tinsCookie) {
				colourAllButton.on('click', function() {
					sessionStorage.setItem("searched-tins", true);
				});
			}

			if (searchButton && aerosolCookie) {
				searchButton.on('click', function() {
					sessionStorage.setItem("searched-aerosol", true);
				});
			}

			if (colourAllButton && aerosolCookie) {
				colourAllButton.on('click', function() {
					sessionStorage.setItem("searched-aerosol", true);
				});
			}

			if (searchButton && bottleCookie) {
				searchButton.on('click', function() {
					sessionStorage.setItem("searched-bottle", true);
				});
			}

			if (colourAllButton && bottleCookie) {
				colourAllButton.on('click', function() {
					sessionStorage.setItem("searched-bottle", true);
				});
			}

		});
	}

	var searchPen = sessionStorage.getItem("searched-pen");
	var searchTins = sessionStorage.getItem("searched-tins");
	var searchAerosol = sessionStorage.getItem("searched-aerosol");
	var searchBottle = sessionStorage.getItem("searched-bottle");

	if (searchPen) {
		var colourSelection = document.querySelector('.color-range-block');
		if (colourSelection) {
			$('.swatch-item').each(function() {
				var $this = $(this);
				var _href = $this.attr("href");
				$this.attr("href", _href + '?attribute_pa_product=paint-pen-product');
			});

		} else {
			sessionStorage.removeItem("searched-pen");
		}
	}

	if (searchTins) {
		var colourSelection = document.querySelector('.color-range-block');
		if (colourSelection) {
			$('.swatch-item').each(function() {
				var $this = $(this);
				var _href = $this.attr("href");
				$this.attr("href", _href + '?attribute_pa_product=paint-tins-product');
			});

		} else {
			sessionStorage.removeItem("searched-tins");
		}
	}

	if (searchAerosol) {
		var colourSelection = document.querySelector('.color-range-block');
		if (colourSelection) {
			$('.swatch-item').each(function() {
				var $this = $(this);
				var _href = $this.attr("href");
				$this.attr("href", _href + '?attribute_pa_product=aerosol-product');
			});

		} else {
			sessionStorage.removeItem("searched-aerosol");
		}
	}

	if (searchBottle) {
		var colourSelection = document.querySelector('.color-range-block');
		if (colourSelection) {
			$('.swatch-item').each(function() {
				var $this = $(this);
				var _href = $this.attr("href");
				$this.attr("href", _href + '?attribute_pa_product=paint-bottle-product');
			});

		} else {
			sessionStorage.removeItem("searched-bottle");
		}
	}

	if (window.location.href.indexOf("?attribute_pa_product=") > -1) {
		$( window ).on( "load", function() {
			document.querySelector('#pa_kitContainer').classList.remove('d-none');

			// Standard Difference Items
			var standardDifference = document.querySelector('.standard-difference');
			var standardDifferenceMB = document.querySelector('.standard-difference-mobile');
			var standardTitle = document.querySelector('.package-title-container');
			var standardDescription = document.querySelector('.package-description');
			var standardTitleMB = document.querySelector('.package-mb-title-container');
			var standardDescriptionMB = document.querySelector('.package-mb-description-container');

			// Pen Difference Items
			var penDifference = document.querySelector('.pen-difference');
			var penDifferenceMB = document.querySelector('.pen-difference-mobile');
			var penTitle = document.querySelector('.pen-title-container');
			var penDescription = document.querySelector('.pen-description');
			var penTitleMB = document.querySelector('.pen-mb-title-container');
			var penDescriptionMB = document.querySelector('.pen-mb-description-container');

			// Aerosol Difference Items
			var aerosolDifference = document.querySelector('.aerosol-difference');
			var aerosolDifferenceMB = document.querySelector('.aerosol-difference-mobile');
			var aerosolTitle = document.querySelector('.aerosol-title-container');
			var aerosolDescription = document.querySelector('.aerosol-description');
			var aerosolTitleMB = document.querySelector('.aerosol-mb-title-container');
			var aerosolDescriptionMB = document.querySelector('.aerosol-mb-description-container');

			// Bottle Difference Items
			var bottleDifference = document.querySelector('.bottle-difference');
			var bottleDifferenceMB = document.querySelector('.bottle-difference-mobile');
			var bottleTitle = document.querySelector('.bottle-title-container');
			var bottleDescription = document.querySelector('.bottle-description');
			var bottleTitleMB = document.querySelector('.bottle-mb-title-container');
			var bottleDescriptionMB = document.querySelector('.bottle-mb-description-container');

			// Tins Difference Items
			var tinsDifference = document.querySelector('.tins-difference');
			var tinsDifferenceMB = document.querySelector('.tins-difference-mobile');
			var tinsTitle = document.querySelector('.tins-title-container');
			var tinsDescription = document.querySelector('.tins-description');
			var tinsTitleMB = document.querySelector('.tins-mb-title-container');
			var tinsDescriptionMB = document.querySelector('.tins-mb-description-container');

			if (window.location.href.indexOf("=paint-pen-product") > -1) {
				penDifference.classList.remove('d-none');
				penDifference.classList.add('d-flex');
				penTitle.classList.remove('d-none');
				penTitle.classList.add('d-flex');
				penDifferenceMB.classList.remove('d-none');
				penDifferenceMB.classList.add('d-block');
				penTitleMB.classList.remove('d-none');
				penTitleMB.classList.add('d-block');

				if (penDescription) {
					penDescription.classList.add('d-block');
					penDescription.classList.remove('d-none');
					penDescriptionMB.classList.add('d-block');
					penDescriptionMB.classList.remove('d-none');
				}

				if (standardDifference.classList.contains('d-flex')) {
					standardDifference.classList.remove('d-flex');
					standardDifference.classList.add('d-none');
					standardTitle.classList.remove('d-flex');
					standardTitle.classList.add('d-none');
					standardDescription.classList.remove('d-block');
					standardDescription.classList.add('d-none');
					standardDifferenceMB.classList.remove('d-block');
					standardDifferenceMB.classList.add('d-none');
					standardTitleMB.classList.remove('d-block');
					standardTitleMB.classList.add('d-none');
					standardDescriptionMB.classList.remove('d-block');
					standardDescriptionMB.classList.add('d-none');
				}

				if (aerosolDifference.classList.contains('d-flex')) {
					aerosolDifference.classList.remove('d-flex');
					aerosolDifference.classList.add('d-none');
					aerosolTitle.classList.remove('d-flex');
					aerosolTitle.classList.add('d-none');
					aerosolDifferenceMB.classList.remove('d-block');
					aerosolDifferenceMB.classList.add('d-none');
					aerosolTitleMB.classList.remove('d-block');
					aerosolTitleMB.classList.add('d-none');

					if (aerosolDescription) {
						aerosolDescription.classList.remove('d-block');
						aerosolDescription.classList.add('d-none');
						aerosolDescriptionMB.classList.remove('d-block');
						aerosolDescriptionMB.classList.add('d-none');
					}
				}

				if (bottleDifference.classList.contains('d-flex')) {
					bottleDifference.classList.remove('d-flex');
					bottleDifference.classList.add('d-none');
					bottleTitle.classList.remove('d-flex');
					bottleTitle.classList.add('d-none');
					bottleDifferenceMB.classList.remove('d-block');
					bottleDifferenceMB.classList.add('d-none');
					bottleTitleMB.classList.remove('d-block');
					bottleTitleMB.classList.add('d-none');

					if (bottleDescription) {
						bottleDescription.classList.remove('d-block');
						bottleDescription.classList.add('d-none');
						bottleDescriptionMB.classList.remove('d-block');
						bottleDescriptionMB.classList.add('d-none');
					}
				}

				if (tinsDifference.classList.contains('d-flex')) {
					tinsDifference.classList.remove('d-flex');
					tinsDifference.classList.add('d-none');
					tinsTitle.classList.remove('d-flex');
					tinsTitle.classList.add('d-none');
					tinsDifferenceMB.classList.remove('d-block');
					tinsDifferenceMB.classList.add('d-none');
					tinsTitleMB.classList.remove('d-block');
					tinsTitleMB.classList.add('d-none');

					if (tinsDescription) {
						tinsDescription.classList.remove('d-block');
						tinsDescription.classList.add('d-none');
						tinsDescriptionMB.classList.remove('d-block');
						tinsDescriptionMB.classList.add('d-none');
					}
				}
			}

			if (window.location.href.indexOf("=aerosol-product") > -1) {
				aerosolDifference.classList.remove('d-none');
				aerosolDifference.classList.add('d-flex');
				aerosolTitle.classList.remove('d-none');
				aerosolTitle.classList.add('d-flex');
				aerosolDifferenceMB.classList.remove('d-none');
				aerosolDifferenceMB.classList.add('d-block');
				aerosolTitleMB.classList.remove('d-none');
				aerosolTitleMB.classList.add('d-block');

				if (aerosolDescription) {
					aerosolDescription.classList.add('d-block');
					aerosolDescription.classList.remove('d-none');
					aerosolDescriptionMB.classList.add('d-block');
					aerosolDescriptionMB.classList.remove('d-none');
				}

				if (standardDifference.classList.contains('d-flex')) {
					standardDifference.classList.remove('d-flex');
					standardDifference.classList.add('d-none');
					standardTitle.classList.remove('d-flex');
					standardTitle.classList.add('d-none');
					standardDescription.classList.remove('d-block');
					standardDescription.classList.add('d-none');
					standardDifferenceMB.classList.remove('d-block');
					standardDifferenceMB.classList.add('d-none');
					standardTitleMB.classList.remove('d-block');
					standardTitleMB.classList.add('d-none');
					standardDescriptionMB.classList.remove('d-block');
					standardDescriptionMB.classList.add('d-none');
				}

				if (penDifference.classList.contains('d-flex')) {
					penDifference.classList.remove('d-flex');
					penDifference.classList.add('d-none');
					penTitle.classList.remove('d-flex');
					penTitle.classList.add('d-none');
					penDifferenceMB.classList.remove('d-block');
					penDifferenceMB.classList.add('d-none');
					penTitleMB.classList.remove('d-block');
					penTitleMB.classList.add('d-none');

					if (penDescription) {
						penDescription.classList.remove('d-block');
						penDescription.classList.add('d-none');
						penDescriptionMB.classList.remove('d-block');
						penDescriptionMB.classList.add('d-none');
					}
				}

				if (bottleDifference.classList.contains('d-flex')) {
					bottleDifference.classList.remove('d-flex');
					bottleDifference.classList.add('d-none');
					bottleTitle.classList.remove('d-flex');
					bottleTitle.classList.add('d-none');
					bottleDifferenceMB.classList.remove('d-block');
					bottleDifferenceMB.classList.add('d-none');
					bottleTitleMB.classList.remove('d-block');
					bottleTitleMB.classList.add('d-none');

					if (bottleDescription) {
						bottleDescription.classList.remove('d-block');
						bottleDescription.classList.add('d-none');
						bottleDescriptionMB.classList.remove('d-block');
						bottleDescriptionMB.classList.add('d-none');
					}
				}

				if (tinsDifference.classList.contains('d-flex')) {
					tinsDifference.classList.remove('d-flex');
					tinsDifference.classList.add('d-none');
					tinsTitle.classList.remove('d-flex');
					tinsTitle.classList.add('d-none');
					tinsDifferenceMB.classList.remove('d-block');
					tinsDifferenceMB.classList.add('d-none');
					tinsTitleMB.classList.remove('d-block');
					tinsTitleMB.classList.add('d-none');

					if (tinsDescription) {
						tinsDescription.classList.remove('d-block');
						tinsDescription.classList.add('d-none');
						tinsDescriptionMB.classList.remove('d-block');
						tinsDescriptionMB.classList.add('d-none');
					}
				}
			}

			if (window.location.href.indexOf("=paint-bottle-product") > -1) {
				bottleDifference.classList.remove('d-none');
				bottleDifference.classList.add('d-flex');
				bottleTitle.classList.remove('d-none');
				bottleTitle.classList.add('d-flex');
				bottleDifferenceMB.classList.remove('d-none');
				bottleDifferenceMB.classList.add('d-block');
				bottleTitleMB.classList.remove('d-none');
				bottleTitleMB.classList.add('d-block');

				if (bottleDescription) {
					bottleDescription.classList.add('d-block');
					bottleDescription.classList.remove('d-none');
					bottleDescriptionMB.classList.add('d-block');
					bottleDescriptionMB.classList.remove('d-none');
				}

				if (standardDifference.classList.contains('d-flex')) {
					standardDifference.classList.remove('d-flex');
					standardDifference.classList.add('d-none');
					standardTitle.classList.remove('d-flex');
					standardTitle.classList.add('d-none');
					standardDescription.classList.remove('d-block');
					standardDescription.classList.add('d-none');
					standardDifferenceMB.classList.remove('d-block');
					standardDifferenceMB.classList.add('d-none');
					standardTitleMB.classList.remove('d-block');
					standardTitleMB.classList.add('d-none');
					standardDescriptionMB.classList.remove('d-block');
					standardDescriptionMB.classList.add('d-none');
				}

				if (penDifference.classList.contains('d-flex')) {
					penDifference.classList.remove('d-flex');
					penDifference.classList.add('d-none');
					penTitle.classList.remove('d-flex');
					penTitle.classList.add('d-none');
					penDifferenceMB.classList.remove('d-block');
					penDifferenceMB.classList.add('d-none');
					penTitleMB.classList.remove('d-block');
					penTitleMB.classList.add('d-none');

					if (penDescription) {
						penDescription.classList.remove('d-block');
						penDescription.classList.add('d-none');
						penDescriptionMB.classList.remove('d-block');
						penDescriptionMB.classList.add('d-none');
					}
				}

				if (aerosolDifference.classList.contains('d-flex')) {
					aerosolDifference.classList.remove('d-flex');
					aerosolDifference.classList.add('d-none');
					aerosolTitle.classList.remove('d-flex');
					aerosolTitle.classList.add('d-none');
					aerosolDifferenceMB.classList.remove('d-block');
					aerosolDifferenceMB.classList.add('d-none');
					aerosolTitleMB.classList.remove('d-block');
					aerosolTitleMB.classList.add('d-none');

					if (aerosolDescription) {
						aerosolDescription.classList.remove('d-block');
						aerosolDescription.classList.add('d-none');
						aerosolDescriptionMB.classList.remove('d-block');
						aerosolDescriptionMB.classList.add('d-none');
					}
				}

				if (tinsDifference.classList.contains('d-flex')) {
					tinsDifference.classList.remove('d-flex');
					tinsDifference.classList.add('d-none');
					tinsTitle.classList.remove('d-flex');
					tinsTitle.classList.add('d-none');
					tinsDifferenceMB.classList.remove('d-block');
					tinsDifferenceMB.classList.add('d-none');
					tinsTitleMB.classList.remove('d-block');
					tinsTitleMB.classList.add('d-none');

					if (tinsDescription) {
						tinsDescription.classList.remove('d-block');
						tinsDescription.classList.add('d-none');
						tinsDescriptionMB.classList.remove('d-block');
						tinsDescriptionMB.classList.add('d-none');
					}
				}
			}

			if (window.location.href.indexOf("=paint-tins-product") > -1) {
				tinsDifference.classList.remove('d-none');
				tinsDifference.classList.add('d-flex');
				tinsTitle.classList.remove('d-none');
				tinsTitle.classList.add('d-flex');
				tinsDifferenceMB.classList.remove('d-none');
				tinsDifferenceMB.classList.add('d-block');
				tinsTitleMB.classList.remove('d-none');
				tinsTitleMB.classList.add('d-block');

				if (tinsDescription) {
					tinsDescription.classList.add('d-block');
					tinsDescription.classList.remove('d-none');
					tinsDescriptionMB.classList.add('d-block');
					tinsDescriptionMB.classList.remove('d-none');
				}

				if (standardDifference.classList.contains('d-flex')) {
					standardDifference.classList.remove('d-flex');
					standardDifference.classList.add('d-none');
					standardTitle.classList.remove('d-flex');
					standardTitle.classList.add('d-none');
					standardDescription.classList.remove('d-block');
					standardDescription.classList.add('d-none');
					standardDifferenceMB.classList.remove('d-block');
					standardDifferenceMB.classList.add('d-none');
					standardTitleMB.classList.remove('d-block');
					standardTitleMB.classList.add('d-none');
					standardDescriptionMB.classList.remove('d-block');
					standardDescriptionMB.classList.add('d-none');
				}

				if (penDifference.classList.contains('d-flex')) {
					penDifference.classList.remove('d-flex');
					penDifference.classList.add('d-none');
					penTitle.classList.remove('d-flex');
					penTitle.classList.add('d-none');
					penDifferenceMB.classList.remove('d-block');
					penDifferenceMB.classList.add('d-none');
					penTitleMB.classList.remove('d-block');
					penTitleMB.classList.add('d-none');

					if (penDescription) {
						penDescription.classList.remove('d-block');
						penDescription.classList.add('d-none');
						penDescriptionMB.classList.remove('d-block');
						penDescriptionMB.classList.add('d-none');
					}
				}

				if (aerosolDifference.classList.contains('d-flex')) {
					aerosolDifference.classList.remove('d-flex');
					aerosolDifference.classList.add('d-none');
					aerosolTitle.classList.remove('d-flex');
					aerosolTitle.classList.add('d-none');
					aerosolDifferenceMB.classList.remove('d-block');
					aerosolDifferenceMB.classList.add('d-none');
					aerosolTitleMB.classList.remove('d-block');
					aerosolTitleMB.classList.add('d-none');

					if (aerosolDescription) {
						aerosolDescription.classList.remove('d-block');
						aerosolDescription.classList.add('d-none');
						aerosolDescriptionMB.classList.remove('d-block');
						aerosolDescriptionMB.classList.add('d-none');
					}
				}

				if (bottleDifference.classList.contains('d-flex')) {
					bottleDifference.classList.remove('d-flex');
					bottleDifference.classList.add('d-none');
					bottleTitle.classList.remove('d-flex');
					bottleTitle.classList.add('d-none');
					bottleDifferenceMB.classList.remove('d-block');
					bottleDifferenceMB.classList.add('d-none');
					bottleTitleMB.classList.remove('d-block');
					bottleTitleMB.classList.add('d-none');

					if (bottleDescription) {
						bottleDescription.classList.remove('d-block');
						bottleDescription.classList.add('d-none');
						bottleDescriptionMB.classList.remove('d-block');
						bottleDescriptionMB.classList.add('d-none');
					}
				}
			}
		});
	}

	if (window.location.href.indexOf("&attribute_pa_kit=") > -1) {
		$( window ).on( "load", function() {
			if (document.querySelector(".add-to-cart") && document.querySelector("template")) {
				document.querySelector(".add-to-cart").classList.remove("disabled");
			} else {
				if (document.querySelector(".add-to-cart")) {
					document.querySelector(".add-to-cart").classList.remove("disabled");
					document.querySelector(".add-to-cart").removeAttribute("disabled");
				}
			}
		});
	}



})(jQuery);

// Manufacturer Click

(function($) {

	$(document).ready(function() {
		var select = document.querySelector('.search-car-block');

		if (select) {
			$('.search-car-container').each(function () {
				const $this = $(this);
				var selectBrand = $this.find('.brand-select');
				var prefix = document.querySelector('.prefix-url');
				var prefixMC = document.querySelector('.prefix-motorbike-url');

				function constructURL () {
					var baseUrl = window.site.url;
					var prefixVal = prefix.innerHTML;
					var brand = selectBrand.val();
					var url = baseUrl + prefixVal + "/" + brand;
					return url;
				}

				function constructMBURL () {
					var baseUrl = window.site.url;
					var prefixVal = prefixMC.innerHTML;
					var brand = selectBrand.val();
					var url = baseUrl + prefixVal + "/" + brand;
					return url;
				}

				selectBrand.on('change', function() {
					var brand_val = $(this).val();
					if (brand_val === "harley-davidson" || brand_val === "kawasaki" || brand_val === "vespa" || brand_val === "yamaha") {
						var url = constructMBURL();
					} else {
						var url = constructURL();
					}

					window.location.href = url;
				});
			});
		}

	})

})(jQuery);

// Colour Sticky Bar

(function($) {

	$(document).ready(function() {
		const isDesktop = $(window).width() > 991;
		const ROPContainer = document.querySelector(".search-pan-ral-colour-container");

		if (ROPContainer) {

			if (isDesktop) {
				desktopROPScroll();

			} else {
				mobileROPScroll();
			}

			$(window).resize(function () {
				const isDesktop = $(window).width() > 991;

				if (isDesktop) {
					desktopROPScroll();
				} else {
					mobileROPScroll();
				}
			});

			function desktopROPScroll() {
				const ROPMobileStick = document.querySelector(".pan-ral-card-sticky");
				var stickyMenu = document.querySelector('.sticky-card-wrapper');
				var noScrollBehind = document.querySelector('.page');

				if (stickyMenu.classList.contains("active")) {
					stickyMenu.classList.remove("active");
					document.body.style.overflow = 'auto';
					noScrollBehind.classList.toggle('disable-scroll');
				}

				if (!ROPMobileStick.classList.contains("d-none")) {
					ROPMobileStick.classList.add("d-none");
				}

				if (!ROPContainer.classList.contains("sticky-top")) {
					ROPContainer.classList.add("sticky-top");
				}

				// Sticky styling
				const el = document.querySelector(".sticky-top");

				const observer = new IntersectionObserver(
					([e]) => e.target.classList.toggle("has-stuck", e.intersectionRatio < 1),
					{ threshold: [1] }
				);

				observer.observe(el);
			}

			function mobileROPScroll() {
				if (ROPContainer.classList.contains("sticky-top")) {
					ROPContainer.classList.remove("sticky-top");
				}

				var searchBar = document.querySelector('.search-pan-ral-colour-container');

				var searchTop = $(searchBar).offset().top;
				var searchHeight = $(searchBar).outerHeight();

				$(window).scroll(function(){
					const isDesktop = $(window).width() > 991;

					if (!isDesktop) {
						if($(window).scrollTop() > (searchTop + searchHeight)){
							document.querySelector('.pan-ral-card-sticky').classList.remove('d-none');
						}
						else{
							document.querySelector('.pan-ral-card-sticky').classList.add('d-none');
						}
					}
				});
			}

			var sticky = document.querySelector('.pan-ral-card-sticky');
			var stickyButton = sticky.querySelector('.btn-sticky');

			var stickyMenu = document.querySelector('.sticky-card-wrapper');
			var stickyClose = stickyMenu.querySelector('.btn-sticky-card-clear');

			var noScrollBehind = document.querySelector('.page');


			if (stickyButton) {
				stickyButton.addEventListener('click', function() {
					stickyMenu.classList.toggle('active');
					document.body.style.overflow = 'hidden';
					noScrollBehind.classList.toggle('disable-scroll');
				});
			}

			if (stickyClose) {
				stickyClose.addEventListener('click', function() {
					stickyMenu.classList.toggle('active');
					document.body.style.overflow = 'auto';
					noScrollBehind.classList.toggle('disable-scroll');
				});
			}
		}
	})

})(jQuery);

// Summary Open Animation Text

(function($) {

	$(document).ready(function() {
		const details = document.querySelector(".product-text-open");
		if (details) {
			details.addEventListener("click", () => {
				if (details.hasAttribute("open")) {
					details.classList.remove("animate");
				} else {
					details.classList.add("animate");
				}
			});
		}
	})

})(jQuery);

// Variations

(function($) {

	$(document).ready(function() {
		var descriptions = document.querySelector('.single_variation');

		// Enabling last child variation
		if (descriptions) {
			descriptions.remove();
		}

		// Take input out of container to enable styling
		$('.woovr-variation').each(function() {

			var activeImage = this.querySelector('.woovr-variation-image');
			var activeImageHTML = activeImage.innerHTML;

			var info = this.querySelector('.woovr-variation-info');
			$(info).prepend($(activeImageHTML));

			if (activeImage) {
				activeImage.remove();
			}

			var activeRadio = this.querySelector('.woovr-variation-selector');
			var activeRadioHTML = activeRadio.innerHTML;


			// Adding carousel image into the missing active image position
			// activeVariationContainer.prepend(activeRadioHTML);
			$(this).prepend($(activeRadioHTML));

			// Removing active image to make place for the image selected from carousel
			if (activeRadio) {
				activeRadio.remove();
			}

			var enableButton = this.querySelector('.woovr-variation-info');

			$(enableButton).on('click', function() {

				if (document.querySelector(".add-to-cart")) {
					document.querySelector(".add-to-cart").classList.remove("disabled");
					document.querySelector(".add-to-cart").removeAttribute("disabled");
				}

			});

		});


		// New images
		var variationBackground = document.querySelector('.pa_product');
		var variationContainer = document.querySelectorAll('.variation-container');
		var addToCart = document.querySelector(".add-to-cart");
		var ccContainer = document.querySelector('.custom-colour-fields');
		var productTxt = document.querySelector('.variations_form .content');

		var ppcPen = document.querySelector('.pa_pen');
		var ppcAerosol = document.querySelector('.pa_aerosol');
		var ppcBottle = document.querySelector('.pa_bottle');
		var ppcTins = document.querySelector('.pa_tins');

		// Standard Difference Items
		var standardDifference = document.querySelector('.standard-difference');
		var standardDifferenceMB = document.querySelector('.standard-difference-mobile');
		var standardTitle = document.querySelector('.package-title-container');
		var standardDescription = document.querySelector('.package-description');
		var standardTitleMB = document.querySelector('.package-mb-title-container');
		var standardDescriptionMB = document.querySelector('.package-mb-description-container');

		// Pen Difference Items
		var penDifference = document.querySelector('.pen-difference');
		var penDifferenceMB = document.querySelector('.pen-difference-mobile');
		var penTitle = document.querySelector('.pen-title-container');
		var penDescription = document.querySelector('.pen-description');
		var penTitleMB = document.querySelector('.pen-mb-title-container');
		var penDescriptionMB = document.querySelector('.pen-mb-description-container');

		// Aerosol Difference Items
		var aerosolDifference = document.querySelector('.aerosol-difference');
		var aerosolDifferenceMB = document.querySelector('.aerosol-difference-mobile');
		var aerosolTitle = document.querySelector('.aerosol-title-container');
		var aerosolDescription = document.querySelector('.aerosol-description');
		var aerosolTitleMB = document.querySelector('.aerosol-mb-title-container');
		var aerosolDescriptionMB = document.querySelector('.aerosol-mb-description-container');

		// Bottle Difference Items
		var bottleDifference = document.querySelector('.bottle-difference');
		var bottleDifferenceMB = document.querySelector('.bottle-difference-mobile');
		var bottleTitle = document.querySelector('.bottle-title-container');
		var bottleDescription = document.querySelector('.bottle-description');
		var bottleTitleMB = document.querySelector('.bottle-mb-title-container');
		var bottleDescriptionMB = document.querySelector('.bottle-mb-description-container');

		// Tins Difference Items
		var tinsDifference = document.querySelector('.tins-difference');
		var tinsDifferenceMB = document.querySelector('.tins-difference-mobile');
		var tinsTitle = document.querySelector('.tins-title-container');
		var tinsDescription = document.querySelector('.tins-description');
		var tinsTitleMB = document.querySelector('.tins-mb-title-container');
		var tinsDescriptionMB = document.querySelector('.tins-mb-description-container');

		var productContent = document.querySelector('.product-content');
		var origContentData = productContent.innerHTML;


		if (variationBackground) {
			if (variationBackground) {
				$('.variation-container').each(function() {

					var productContainer = this.querySelectorAll('#pa_productContainer');
					var kitContainer = document.querySelector('#pa_kitContainer');
					var finishContainer = document.querySelector('#pa_finishContainer');
					var clearButton = this.querySelectorAll('.reset_variations');

					if (productContainer && kitContainer) {
						kitContainer.classList.add('d-none');

						$(clearButton).on('click', function() {
							if (!kitContainer.classList.contains('d-none')) {
								kitContainer.classList.add('d-none');

								standardDifference.classList.remove('d-none');
								standardDifference.classList.add('d-flex');
								standardTitle.classList.remove('d-none');
								standardTitle.classList.add('d-flex');
								standardDescription.classList.remove('d-none');
								standardDescription.classList.add('d-block');
								standardDifferenceMB.classList.remove('d-none');
								standardDifferenceMB.classList.add('d-block');
								standardTitleMB.classList.remove('d-none');
								standardTitleMB.classList.add('d-block');
								standardDescriptionMB.classList.remove('d-none');
								standardDescriptionMB.classList.add('d-block');

								if (penDifference.classList.contains('d-flex')) {
									penDifference.classList.remove('d-flex');
									penDifference.classList.add('d-none');
									penTitle.classList.remove('d-flex');
									penTitle.classList.add('d-none');
									penDifferenceMB.classList.remove('d-block');
									penDifferenceMB.classList.add('d-none');
									penTitleMB.classList.remove('d-block');
									penTitleMB.classList.add('d-none');

									if (penDescription) {
										penDescription.classList.remove('d-block');
										penDescription.classList.add('d-none');
										penDescriptionMB.classList.remove('d-block');
										penDescriptionMB.classList.add('d-none');
									}
								}

								if (aerosolDifference.classList.contains('d-flex')) {
									aerosolDifference.classList.remove('d-flex');
									aerosolDifference.classList.add('d-none');
									aerosolTitle.classList.remove('d-flex');
									aerosolTitle.classList.add('d-none');
									aerosolDifferenceMB.classList.remove('d-block');
									aerosolDifferenceMB.classList.add('d-none');
									aerosolTitleMB.classList.remove('d-block');
									aerosolTitleMB.classList.add('d-none');

									if (aerosolDescription) {
										aerosolDescription.classList.remove('d-block');
										aerosolDescription.classList.add('d-none');
										aerosolDescriptionMB.classList.remove('d-block');
										aerosolDescriptionMB.classList.add('d-none');
									}
								}

								if (bottleDifference.classList.contains('d-flex')) {
									bottleDifference.classList.remove('d-flex');
									bottleDifference.classList.add('d-none');
									bottleTitle.classList.remove('d-flex');
									bottleTitle.classList.add('d-none');
									bottleDifferenceMB.classList.remove('d-block');
									bottleDifferenceMB.classList.add('d-none');
									bottleTitleMB.classList.remove('d-block');
									bottleTitleMB.classList.add('d-none');

									if (bottleDescription) {
										bottleDescription.classList.remove('d-block');
										bottleDescription.classList.add('d-none');
										bottleDescriptionMB.classList.remove('d-block');
										bottleDescriptionMB.classList.add('d-none');
									}
								}

								if (tinsDifference.classList.contains('d-flex')) {
									tinsDifference.classList.remove('d-flex');
									tinsDifference.classList.add('d-none');
									tinsTitle.classList.remove('d-flex');
									tinsTitle.classList.add('d-none');
									tinsDifferenceMB.classList.remove('d-block');
									tinsDifferenceMB.classList.add('d-none');
									tinsTitleMB.classList.remove('d-block');
									tinsTitleMB.classList.add('d-none');

									if (tinsDescription) {
										tinsDescription.classList.remove('d-block');
										tinsDescription.classList.add('d-none');
										tinsDescriptionMB.classList.remove('d-block');
										tinsDescriptionMB.classList.add('d-none');
									}
								}
							}
						});
					}

					$(clearButton).on('click', function() {
						addToCart.classList.add('disabled');
						$(addToCart).prop('disabled', true);

						if (productTxt) {
							productTxt.classList.remove('d-none');
						}
					});

					if (productContainer) {
						var productImageOne = this.querySelector('.pen-image-container');
						var productPriceOne = this.querySelector('.pen-price');

						if (productImageOne) {
							var productImageOneHTML = productImageOne.innerHTML;
							var productPriceOneHTML = productPriceOne.outerHTML;

							var productOne = this.querySelector('.button-variable-item-paint-pen-product');
							$(productOne).prepend($(productImageOneHTML));
							$(productOne).append($(productPriceOneHTML));

							productImageOne.remove();
							productPriceOne.remove();
						}


						var productImageTwo = this.querySelector('.aerosol-image-container');
						var productPriceTwo = this.querySelector('.aerosol-price');

						if (productImageTwo) {
							var productImageTwoHTML = productImageTwo.innerHTML;
							var productPriceTwoHTML = productPriceTwo.outerHTML;

							var productTwo = this.querySelector('.button-variable-item-aerosol-product');
							$(productTwo).prepend($(productImageTwoHTML));
							$(productTwo).append($(productPriceTwoHTML));

							productImageTwo.remove();
							productPriceTwo.remove();
						}

						var productImageThree = this.querySelector('.bottle-image-container');
						var productPriceThree = this.querySelector('.bottle-price');

						if (productImageThree) {
							var productImageThreeHTML = productImageThree.innerHTML;
							var productPriceThreeHTML = productPriceThree.outerHTML;

							var productThree = this.querySelector('.button-variable-item-paint-bottle-product');
							$(productThree).prepend($(productImageThreeHTML));
							$(productThree).append($(productPriceThreeHTML));

							productImageThree.remove();
							productPriceThree.remove();
						}

						var productImageFour = this.querySelector('.tins-image-container');
						var productPriceFour = this.querySelector('.tins-price');

						if (productPriceFour) {
							var productImageFourHTML = productImageFour.innerHTML;
							var productPriceFourHTML = productPriceFour.outerHTML;

							var productFour = this.querySelector('.button-variable-item-paint-tins-product');
							$(productFour).prepend($(productImageFourHTML));
							$(productFour).append($(productPriceFourHTML));

							productImageFour.remove();
							productPriceFour.remove();
						}


						var productImageContainer = this.querySelector('.product-image-container');

						if (productImageContainer) {
							productImageContainer.remove();
						}
					}

					$('.variable-item').each(function() {
						var productItem = this;

						$(productItem).on('click', function() {
							var productSelected = this.querySelectorAll('.selected');

							if (productSelected && kitContainer) {
								kitContainer.classList.remove('d-none');

								if (productTxt) {
									productTxt.classList.add('d-none');
								}
							}
						});
					});

					var hasChangedContent = false;

					$('form.variations_form').on('found_variation', function(event, variation) {
						if (variation.additional_variation_title || variation.additional_variation_description) {
							var content = '<div class="additional-variation-content">';
							if (variation.additional_variation_title) {
								content += '<h5 class="mb-0">' + variation.additional_variation_title + '</h5>';
							}
							if (variation.additional_variation_description) {
								content += '<p class="mb-0">' + variation.additional_variation_description + '</p>';
							}
							content += '</div>';
							productContent.innerHTML = content;
							hasChangedContent = true;
						} else if(hasChangedContent) {
							productContent.innerHTML = origContentData;
							hasChangedContent = false;
						}
					}).on('reset_data', function() {
						productContent.innerHTML = origContentData;
					});

					// Difference Block Shifter

					var penClick = document.querySelector('.button-variable-item-paint-pen-product');
					var aerosolClick = document.querySelector('.button-variable-item-aerosol-product');
					var bottleClick = document.querySelector('.button-variable-item-paint-bottle-product');
					var tinsClick = document.querySelector('.button-variable-item-paint-tins-product');

					if (penClick) {
						$(penClick).on('click', function() {
							penDifference.classList.remove('d-none');
							penDifference.classList.add('d-flex');
							penTitle.classList.remove('d-none');
							penTitle.classList.add('d-flex');
							penDifferenceMB.classList.remove('d-none');
							penDifferenceMB.classList.add('d-block');
							penTitleMB.classList.remove('d-none');
							penTitleMB.classList.add('d-block');

							if (penDescription) {
								penDescription.classList.add('d-block');
								penDescription.classList.remove('d-none');
								penDescriptionMB.classList.add('d-block');
								penDescriptionMB.classList.remove('d-none');
							}

							if (standardDifference.classList.contains('d-flex')) {
								standardDifference.classList.remove('d-flex');
								standardDifference.classList.add('d-none');
								standardTitle.classList.remove('d-flex');
								standardTitle.classList.add('d-none');
								standardDescription.classList.remove('d-block');
								standardDescription.classList.add('d-none');
								standardDifferenceMB.classList.remove('d-block');
								standardDifferenceMB.classList.add('d-none');
								standardTitleMB.classList.remove('d-block');
								standardTitleMB.classList.add('d-none');
								standardDescriptionMB.classList.remove('d-block');
								standardDescriptionMB.classList.add('d-none');
							}

							if (aerosolDifference.classList.contains('d-flex')) {
								aerosolDifference.classList.remove('d-flex');
								aerosolDifference.classList.add('d-none');
								aerosolTitle.classList.remove('d-flex');
								aerosolTitle.classList.add('d-none');
								aerosolDifferenceMB.classList.remove('d-block');
								aerosolDifferenceMB.classList.add('d-none');
								aerosolTitleMB.classList.remove('d-block');
								aerosolTitleMB.classList.add('d-none');

								if (aerosolDescription) {
									aerosolDescription.classList.remove('d-block');
									aerosolDescription.classList.add('d-none');
									aerosolDescriptionMB.classList.remove('d-block');
									aerosolDescriptionMB.classList.add('d-none');
								}
							}

							if (bottleDifference.classList.contains('d-flex')) {
								bottleDifference.classList.remove('d-flex');
								bottleDifference.classList.add('d-none');
								bottleTitle.classList.remove('d-flex');
								bottleTitle.classList.add('d-none');
								bottleDifferenceMB.classList.remove('d-block');
								bottleDifferenceMB.classList.add('d-none');
								bottleTitleMB.classList.remove('d-block');
								bottleTitleMB.classList.add('d-none');

								if (bottleDescription) {
									bottleDescription.classList.remove('d-block');
									bottleDescription.classList.add('d-none');
									bottleDescriptionMB.classList.remove('d-block');
									bottleDescriptionMB.classList.add('d-none');
								}
							}

							if (tinsDifference.classList.contains('d-flex')) {
								tinsDifference.classList.remove('d-flex');
								tinsDifference.classList.add('d-none');
								tinsTitle.classList.remove('d-flex');
								tinsTitle.classList.add('d-none');
								tinsDifferenceMB.classList.remove('d-block');
								tinsDifferenceMB.classList.add('d-none');
								tinsTitleMB.classList.remove('d-block');
								tinsTitleMB.classList.add('d-none');

								if (tinsDescription) {
									tinsDescription.classList.remove('d-block');
									tinsDescription.classList.add('d-none');
									tinsDescriptionMB.classList.remove('d-block');
									tinsDescriptionMB.classList.add('d-none');
								}
							}
						});
					}

					if (aerosolClick) {
						$(aerosolClick).on('click', function() {
							aerosolDifference.classList.remove('d-none');
							aerosolDifference.classList.add('d-flex');
							aerosolTitle.classList.remove('d-none');
							aerosolTitle.classList.add('d-flex');
							aerosolDifferenceMB.classList.remove('d-none');
							aerosolDifferenceMB.classList.add('d-block');
							aerosolTitleMB.classList.remove('d-none');
							aerosolTitleMB.classList.add('d-block');

							if (aerosolDescription) {
								aerosolDescription.classList.add('d-block');
								aerosolDescription.classList.remove('d-none');
								aerosolDescriptionMB.classList.add('d-block');
								aerosolDescriptionMB.classList.remove('d-none');
							}

							if (standardDifference.classList.contains('d-flex')) {
								standardDifference.classList.remove('d-flex');
								standardDifference.classList.add('d-none');
								standardTitle.classList.remove('d-flex');
								standardTitle.classList.add('d-none');
								standardDescription.classList.remove('d-block');
								standardDescription.classList.add('d-none');
								standardDifferenceMB.classList.remove('d-block');
								standardDifferenceMB.classList.add('d-none');
								standardTitleMB.classList.remove('d-block');
								standardTitleMB.classList.add('d-none');
								standardDescriptionMB.classList.remove('d-block');
								standardDescriptionMB.classList.add('d-none');
							}

							if (penDifference.classList.contains('d-flex')) {
								penDifference.classList.remove('d-flex');
								penDifference.classList.add('d-none');
								penTitle.classList.remove('d-flex');
								penTitle.classList.add('d-none');
								penDifferenceMB.classList.remove('d-block');
								penDifferenceMB.classList.add('d-none');
								penTitleMB.classList.remove('d-block');
								penTitleMB.classList.add('d-none');

								if (penDescription) {
									penDescription.classList.remove('d-block');
									penDescription.classList.add('d-none');
									penDescriptionMB.classList.remove('d-block');
									penDescriptionMB.classList.add('d-none');
								}
							}

							if (bottleDifference.classList.contains('d-flex')) {
								bottleDifference.classList.remove('d-flex');
								bottleDifference.classList.add('d-none');
								bottleTitle.classList.remove('d-flex');
								bottleTitle.classList.add('d-none');
								bottleDifferenceMB.classList.remove('d-block');
								bottleDifferenceMB.classList.add('d-none');
								bottleTitleMB.classList.remove('d-block');
								bottleTitleMB.classList.add('d-none');

								if (bottleDescription) {
									bottleDescription.classList.remove('d-block');
									bottleDescription.classList.add('d-none');
									bottleDescriptionMB.classList.remove('d-block');
									bottleDescriptionMB.classList.add('d-none');
								}
							}

							if (tinsDifference.classList.contains('d-flex')) {
								tinsDifference.classList.remove('d-flex');
								tinsDifference.classList.add('d-none');
								tinsTitle.classList.remove('d-flex');
								tinsTitle.classList.add('d-none');
								tinsDifferenceMB.classList.remove('d-block');
								tinsDifferenceMB.classList.add('d-none');
								tinsTitleMB.classList.remove('d-block');
								tinsTitleMB.classList.add('d-none');

								if (tinsDescription) {
									tinsDescription.classList.remove('d-block');
									tinsDescription.classList.add('d-none');
									tinsDescriptionMB.classList.remove('d-block');
									tinsDescriptionMB.classList.add('d-none');
								}
							}
						});
					}

					if (bottleClick) {
						$(bottleClick).on('click', function() {
							bottleDifference.classList.remove('d-none');
							bottleDifference.classList.add('d-flex');
							bottleTitle.classList.remove('d-none');
							bottleTitle.classList.add('d-flex');
							bottleDifferenceMB.classList.remove('d-none');
							bottleDifferenceMB.classList.add('d-block');
							bottleTitleMB.classList.remove('d-none');
							bottleTitleMB.classList.add('d-block');

							if (bottleDescription) {
								bottleDescription.classList.add('d-block');
								bottleDescription.classList.remove('d-none');
								bottleDescriptionMB.classList.add('d-block');
								bottleDescriptionMB.classList.remove('d-none');
							}

							if (standardDifference.classList.contains('d-flex')) {
								standardDifference.classList.remove('d-flex');
								standardDifference.classList.add('d-none');
								standardTitle.classList.remove('d-flex');
								standardTitle.classList.add('d-none');
								standardDescription.classList.remove('d-block');
								standardDescription.classList.add('d-none');
								standardDifferenceMB.classList.remove('d-block');
								standardDifferenceMB.classList.add('d-none');
								standardTitleMB.classList.remove('d-block');
								standardTitleMB.classList.add('d-none');
								standardDescriptionMB.classList.remove('d-block');
								standardDescriptionMB.classList.add('d-none');
							}

							if (penDifference.classList.contains('d-flex')) {
								penDifference.classList.remove('d-flex');
								penDifference.classList.add('d-none');
								penTitle.classList.remove('d-flex');
								penTitle.classList.add('d-none');
								penDifferenceMB.classList.remove('d-block');
								penDifferenceMB.classList.add('d-none');
								penTitleMB.classList.remove('d-block');
								penTitleMB.classList.add('d-none');

								if (penDescription) {
									penDescription.classList.remove('d-block');
									penDescription.classList.add('d-none');
									penDescriptionMB.classList.remove('d-block');
									penDescriptionMB.classList.add('d-none');
								}
							}

							if (aerosolDifference.classList.contains('d-flex')) {
								aerosolDifference.classList.remove('d-flex');
								aerosolDifference.classList.add('d-none');
								aerosolTitle.classList.remove('d-flex');
								aerosolTitle.classList.add('d-none');
								aerosolDifferenceMB.classList.remove('d-block');
								aerosolDifferenceMB.classList.add('d-none');
								aerosolTitleMB.classList.remove('d-block');
								aerosolTitleMB.classList.add('d-none');

								if (aerosolDescription) {
									aerosolDescription.classList.remove('d-block');
									aerosolDescription.classList.add('d-none');
									aerosolDescriptionMB.classList.remove('d-block');
									aerosolDescriptionMB.classList.add('d-none');
								}
							}

							if (tinsDifference.classList.contains('d-flex')) {
								tinsDifference.classList.remove('d-flex');
								tinsDifference.classList.add('d-none');
								tinsTitle.classList.remove('d-flex');
								tinsTitle.classList.add('d-none');
								tinsDifferenceMB.classList.remove('d-block');
								tinsDifferenceMB.classList.add('d-none');
								tinsTitleMB.classList.remove('d-block');
								tinsTitleMB.classList.add('d-none');

								if (tinsDescription) {
									tinsDescription.classList.remove('d-block');
									tinsDescription.classList.add('d-none');
									tinsDescriptionMB.classList.remove('d-block');
									tinsDescriptionMB.classList.add('d-none');
								}
							}
						});
					}

					if (tinsClick) {
						$(tinsClick).on('click', function() {
							tinsDifference.classList.remove('d-none');
							tinsDifference.classList.add('d-flex');
							tinsTitle.classList.remove('d-none');
							tinsTitle.classList.add('d-flex');
							tinsDifferenceMB.classList.remove('d-none');
							tinsDifferenceMB.classList.add('d-block');
							tinsTitleMB.classList.remove('d-none');
							tinsTitleMB.classList.add('d-block');

							if (tinsDescription) {
								tinsDescription.classList.add('d-block');
								tinsDescription.classList.remove('d-none');
								tinsDescriptionMB.classList.add('d-block');
								tinsDescriptionMB.classList.remove('d-none');
							}

							if (standardDifference.classList.contains('d-flex')) {
								standardDifference.classList.remove('d-flex');
								standardDifference.classList.add('d-none');
								standardTitle.classList.remove('d-flex');
								standardTitle.classList.add('d-none');
								standardDescription.classList.remove('d-block');
								standardDescription.classList.add('d-none');
								standardDifferenceMB.classList.remove('d-block');
								standardDifferenceMB.classList.add('d-none');
								standardTitleMB.classList.remove('d-block');
								standardTitleMB.classList.add('d-none');
								standardDescriptionMB.classList.remove('d-block');
								standardDescriptionMB.classList.add('d-none');
							}

							if (penDifference.classList.contains('d-flex')) {
								penDifference.classList.remove('d-flex');
								penDifference.classList.add('d-none');
								penTitle.classList.remove('d-flex');
								penTitle.classList.add('d-none');
								penDifferenceMB.classList.remove('d-block');
								penDifferenceMB.classList.add('d-none');
								penTitleMB.classList.remove('d-block');
								penTitleMB.classList.add('d-none');

								if (penDescription) {
									penDescription.classList.remove('d-block');
									penDescription.classList.add('d-none');
									penDescriptionMB.classList.remove('d-block');
									penDescriptionMB.classList.add('d-none');
								}
							}

							if (aerosolDifference.classList.contains('d-flex')) {
								aerosolDifference.classList.remove('d-flex');
								aerosolDifference.classList.add('d-none');
								aerosolTitle.classList.remove('d-flex');
								aerosolTitle.classList.add('d-none');
								aerosolDifferenceMB.classList.remove('d-block');
								aerosolDifferenceMB.classList.add('d-none');
								aerosolTitleMB.classList.remove('d-block');
								aerosolTitleMB.classList.add('d-none');

								if (aerosolDescription) {
									aerosolDescription.classList.remove('d-block');
									aerosolDescription.classList.add('d-none');
									aerosolDescriptionMB.classList.remove('d-block');
									aerosolDescriptionMB.classList.add('d-none');
								}
							}

							if (bottleDifference.classList.contains('d-flex')) {
								bottleDifference.classList.remove('d-flex');
								bottleDifference.classList.add('d-none');
								bottleTitle.classList.remove('d-flex');
								bottleTitle.classList.add('d-none');
								bottleDifferenceMB.classList.remove('d-block');
								bottleDifferenceMB.classList.add('d-none');
								bottleTitleMB.classList.remove('d-block');
								bottleTitleMB.classList.add('d-none');

								if (bottleDescription) {
									bottleDescription.classList.remove('d-block');
									bottleDescription.classList.add('d-none');
									bottleDescriptionMB.classList.remove('d-block');
									bottleDescriptionMB.classList.add('d-none');
								}
							}
						});
					}

					var productDetails = this.querySelectorAll('.variation-details-container');

					if (finishContainer) {
						$(productDetails).each(function() {
							if (this) {
								var classList = $(this).attr("class");

								var classArr = classList.split(/\s+/)[1];

								var productDetailsHTML = this.outerHTML;

								var detail = document.querySelector('.button-variable-item-' + classArr);

								$(detail).append($(productDetailsHTML));

								this.remove();

								var classFind = $('.button-variable-item-' + classArr).attr('class');

								$('.pa_kit .variable-item.button-variable-item').each(function(){
									var dupFind = $(this).attr('class');
									var priceCont = $(this).find('.variation-details-container:nth-child(n+3)');
									if(dupFind == classFind){
										$(priceCont).remove();
									}
								});
							}
						});
					} else {
						$(productDetails).each(function() {
							if (this) {
								var classList = $(this).attr("class");

								var classArr = classList.split(/\s+/)[1];

								var productDetailsHTML = this.outerHTML;

								var detail = document.querySelector('.button-variable-item-' + classArr);

								$(detail).append($(productDetailsHTML));

								this.remove();
							}
						});
					}

					$('.pa_kit .variable-item').each(function() {
						var productItem = this;

						$(productItem).on('click', function() {
							var productSelected = this.querySelectorAll('.selected');

							if (productSelected && addToCart) {
								addToCart.classList.remove("disabled");
								addToCart.removeAttribute("disabled");
							}
						});
					});
				});
			}
			else {
				$('.variation-container').each(function() {

					$('.variable-item').each(function() {
						var productItem = this;

						$(productItem).on('click', function() {
							var productSelected = this.querySelectorAll('.selected');

							if (productSelected && addToCart) {
								addToCart.classList.remove("disabled");
								addToCart.removeAttribute("disabled");
							}
						});
					});

					var hasChangedContent = false;

					$('form.variations_form').on('found_variation', function(event, variation) {
						if (variation.additional_variation_title || variation.additional_variation_description) {
							var content = '<div class="additional-variation-content">';
							if (variation.additional_variation_title) {
								content += '<h5 class="mb-0">' + variation.additional_variation_title + '</h5>';
							}
							if (variation.additional_variation_description) {
								content += '<p class="mb-0">' + variation.additional_variation_description + '</p>';
							}
							content += '</div>';
							productContent.innerHTML = content;
							hasChangedContent = true;
						} else if(hasChangedContent) {
							productContent.innerHTML = origContentData;
							hasChangedContent = false;
						}
					}).on('reset_data', function() {
						productContent.innerHTML = origContentData;
					});
				});
			}
		}

		else {
			$('.variation-container').each(function() {
				$('.variable-item').each(function() {
					var productItem = this;

					$(productItem).on('click', function() {
						var productSelected = this.querySelectorAll('.selected');

						if (productSelected && addToCart) {
							addToCart.classList.remove("disabled");
							addToCart.removeAttribute("disabled");
						}
					});
				});

				var hasChangedContent = false;

				$('form.variations_form').on('found_variation', function(event, variation) {
					if (variation.additional_variation_title || variation.additional_variation_description) {
						var content = '<div class="additional-variation-content">';
						if (variation.additional_variation_title) {
							content += '<h5 class="mb-0">' + variation.additional_variation_title + '</h5>';
						}
						if (variation.additional_variation_description) {
							content += '<p class="mb-0">' + variation.additional_variation_description + '</p>';
						}
						content += '</div>';
						productContent.innerHTML = content;
						hasChangedContent = true;
					} else if(hasChangedContent) {
						productContent.innerHTML = origContentData;
						hasChangedContent = false;
					}
				}).on('reset_data', function() {
					productContent.innerHTML = origContentData;
				});
			});
		}


		if (ppcPen || ppcAerosol || ppcBottle || ppcTins) {

			$('.variation-container').each(function() {
				if (this.id === "pa_penContainer") {
					var productImageOne = this.querySelector('.item-one-image-container');
					var productPriceOne = this.querySelector('.price-item-one');

					if (productImageOne) {
						var productImageOneHTML = productImageOne.innerHTML;
						var productPriceOneHTML = productPriceOne.outerHTML;

						var productOne = this.querySelector('.button-variable-item-ppc-paint-pen-kit');
						$(productOne).prepend($(productImageOneHTML));
						$(productOne).append($(productPriceOneHTML));

						productImageOne.remove();
						productPriceOne.remove();
					}


					var productImageTwo = this.querySelector('.item-two-image-container');
					var productPriceTwo = this.querySelector('.price-item-two');

					if (productImageTwo) {
						var productImageTwoHTML = productImageTwo.innerHTML;
						var productPriceTwoHTML = productPriceTwo.outerHTML;

						var productTwo = this.querySelector('.button-variable-item-ppc-paint-primer-base-pen-kit');
						$(productTwo).prepend($(productImageTwoHTML));
						$(productTwo).append($(productPriceTwoHTML));

						productImageTwo.remove();
						productPriceTwo.remove();
					}

					var productImageThree = this.querySelector('.item-three-image-container');
					var productPriceThree = this.querySelector('.price-item-three');

					if (productImageThree) {
						var productImageThreeHTML = productImageThree.innerHTML;
						var productPriceThreeHTML = productPriceThree.outerHTML;

						var productThree = this.querySelector('.button-variable-item-ppc-paint-clear-pen-kit');
						$(productThree).prepend($(productImageThreeHTML));
						$(productThree).append($(productPriceThreeHTML));

						productImageThree.remove();
						productPriceThree.remove();
					}

					var productImageFour = this.querySelector('.item-four-image-container');
					var productPriceFour = this.querySelector('.price-item-four');

					if (productPriceFour) {
						var productImageFourHTML = productImageFour.innerHTML;
						var productPriceFourHTML = productPriceFour.outerHTML;

						var productFour = this.querySelector('.button-variable-item-ppc-paint-everything-pen-kit');
						$(productFour).prepend($(productImageFourHTML));
						$(productFour).append($(productPriceFourHTML));

						productImageFour.remove();
						productPriceFour.remove();
					}


					var productImageContainer = this.querySelector('.product-image-container');

					if (productImageContainer) {
						productImageContainer.remove();
					}
				}

				if (this.id === "pa_aerosolContainer") {
					var productImageOne = this.querySelector('.item-one-image-container');
					var productPriceOne = this.querySelector('.price-item-one');

					if (productImageOne) {
						var productImageOneHTML = productImageOne.innerHTML;
						var productPriceOneHTML = productPriceOne.outerHTML;

						var productOne = this.querySelector('.button-variable-item-ppc-paint-aerosol-kit');
						$(productOne).prepend($(productImageOneHTML));
						$(productOne).append($(productPriceOneHTML));

						productImageOne.remove();
						productPriceOne.remove();
					}

					var productImageTwo = this.querySelector('.item-two-image-container');
					var productPriceTwo = this.querySelector('.price-item-two');

					if (productImageTwo) {
						var productImageTwoHTML = productImageTwo.innerHTML;
						var productPriceTwoHTML = productPriceTwo.outerHTML;

						var productTwo = this.querySelector('.button-variable-item-ppc-paint-all-2k-clear');
						$(productTwo).prepend($(productImageTwoHTML));
						$(productTwo).append($(productPriceTwoHTML));

						productImageTwo.remove();
						productPriceTwo.remove();
					}

					var productImageThree = this.querySelector('.item-three-image-container');
					var productPriceThree = this.querySelector('.price-item-three');

					if (productImageThree) {
						var productImageThreeHTML = productImageThree.innerHTML;
						var productPriceThreeHTML = productPriceThree.outerHTML;

						var productThree = this.querySelector('.button-variable-item-ppc-paint-primer-base-aerosol-kit');
						$(productThree).prepend($(productImageThreeHTML));
						$(productThree).append($(productPriceThreeHTML));

						productImageThree.remove();
						productPriceThree.remove();
					}

					var productImageFour = this.querySelector('.item-four-image-container');
					var productPriceFour = this.querySelector('.price-item-four');

					if (productImageFour) {
						var productImageFourHTML = productImageThree.innerHTML;
						var productPriceFourHTML = productPriceThree.outerHTML;

						var productFour = this.querySelector('.button-variable-item-ppc-paint-clear-aerosol-kit');
						$(productFour).prepend($(productImageFourHTML));
						$(productFour).append($(productPriceFourHTML));

						productImageFour.remove();
						productPriceFour.remove();
					}

					var productImageFive = this.querySelector('.item-five-image-container');
					var productPriceFive = this.querySelector('.price-item-five');

					if (productPriceFive) {
						var productImageFiveHTML = productImageFive.innerHTML;
						var productPriceFiveHTML = productPriceFive.outerHTML;

						var productFive = this.querySelector('.button-variable-item-ppc-paint-everything-aerosol-kit');
						$(productFive).prepend($(productImageFiveHTML));
						$(productFive).append($(productPriceFiveHTML));

						productImageFive.remove();
						productPriceFive.remove();
					}


					var productImageContainer = this.querySelector('.product-image-container');

					if (productImageContainer) {
						productImageContainer.remove();
					}
				}

				if (this.id === "pa_bottleContainer") {
					var productImageOne = this.querySelector('.item-one-image-container');
					var productPriceOne = this.querySelector('.price-item-one');

					if (productImageOne) {
						var productImageOneHTML = productImageOne.innerHTML;
						var productPriceOneHTML = productPriceOne.outerHTML;

						var productOne = this.querySelector('.button-variable-item-ppc-paint-bottle-kit');
						$(productOne).prepend($(productImageOneHTML));
						$(productOne).append($(productPriceOneHTML));

						productImageOne.remove();
						productPriceOne.remove();
					}


					var productImageTwo = this.querySelector('.item-two-image-container');
					var productPriceTwo = this.querySelector('.price-item-two');

					if (productImageTwo) {
						var productImageTwoHTML = productImageTwo.innerHTML;
						var productPriceTwoHTML = productPriceTwo.outerHTML;

						var productTwo = this.querySelector('.button-variable-item-ppc-paint-primer-base-bottle-kit');
						$(productTwo).prepend($(productImageTwoHTML));
						$(productTwo).append($(productPriceTwoHTML));

						productImageTwo.remove();
						productPriceTwo.remove();
					}

					var productImageThree = this.querySelector('.item-three-image-container');
					var productPriceThree = this.querySelector('.price-item-three');

					if (productImageThree) {
						var productImageThreeHTML = productImageThree.innerHTML;
						var productPriceThreeHTML = productPriceThree.outerHTML;

						var productThree = this.querySelector('.button-variable-item-ppc-paint-clear-bottle-kit');
						$(productThree).prepend($(productImageThreeHTML));
						$(productThree).append($(productPriceThreeHTML));

						productImageThree.remove();
						productPriceThree.remove();
					}

					var productImageFour = this.querySelector('.item-four-image-container');
					var productPriceFour = this.querySelector('.price-item-four');

					if (productPriceFour) {
						var productImageFourHTML = productImageFour.innerHTML;
						var productPriceFourHTML = productPriceFour.outerHTML;

						var productFour = this.querySelector('.button-variable-item-ppc-paint-primer-clear-bottle-kit');
						$(productFour).prepend($(productImageFourHTML));
						$(productFour).append($(productPriceFourHTML));

						productImageFour.remove();
						productPriceFour.remove();
					}

					var productImageFive = this.querySelector('.item-five-image-container');
					var productPriceFive = this.querySelector('.price-item-five');

					if (productPriceFive) {
						var productImageFiveHTML = productImageFive.innerHTML;
						var productPriceFiveHTML = productPriceFive.outerHTML;

						var productFive = this.querySelector('.button-variable-item-paint-everything-bottle-kit');
						$(productFive).prepend($(productImageFiveHTML));
						$(productFive).append($(productPriceFiveHTML));

						productImageFive.remove();
						productPriceFive.remove();
					}


					var productImageContainer = this.querySelector('.product-image-container');

					if (productImageContainer) {
						productImageContainer.remove();
					}
				}

				if (this.id === "pa_tinsContainer") {
					var productImageOne = this.querySelector('.item-one-image-container');
					var productPriceOne = this.querySelector('.price-item-one');

					if (productImageOne) {
						var productImageOneHTML = productImageOne.innerHTML;
						var productPriceOneHTML = productPriceOne.outerHTML;

						var productOne = this.querySelector('.button-variable-item-ppc-paint-250-tins-kit');
						$(productOne).prepend($(productImageOneHTML));
						$(productOne).append($(productPriceOneHTML));

						productImageOne.remove();
						productPriceOne.remove();
					}


					var productImageTwo = this.querySelector('.item-two-image-container');
					var productPriceTwo = this.querySelector('.price-item-two');

					if (productImageTwo) {
						var productImageTwoHTML = productImageTwo.innerHTML;
						var productPriceTwoHTML = productPriceTwo.outerHTML;

						var productTwo = this.querySelector('.button-variable-item-ppc-paint-500-tins-kit');
						$(productTwo).prepend($(productImageTwoHTML));
						$(productTwo).append($(productPriceTwoHTML));

						productImageTwo.remove();
						productPriceTwo.remove();
					}

					var productImageThree = this.querySelector('.item-three-image-container');
					var productPriceThree = this.querySelector('.price-item-three');

					if (productImageThree) {
						var productImageThreeHTML = productImageThree.innerHTML;
						var productPriceThreeHTML = productPriceThree.outerHTML;

						var productThree = this.querySelector('.button-variable-item-ppc-paint-1-litre-tins-kit');
						$(productThree).prepend($(productImageThreeHTML));
						$(productThree).append($(productPriceThreeHTML));

						productImageThree.remove();
						productPriceThree.remove();
					}

					var productImageContainer = this.querySelector('.product-image-container');

					if (productImageContainer) {
						productImageContainer.remove();
					}
				}

			});
		}

	});

})(jQuery);

// Cart Items

(function($) {

	$(document).ready(function() {
		var cart_page = document.querySelector('.woocommerce-cart');

		if (cart_page) {
			// Price on plugin

			$('.cuw-offers').each(function () {
				var priceContainer = this.querySelector('.cuw-product-price');
				var priceHTML = '<p class="mb-0">Price</p>';

				$(priceContainer).prepend($(priceHTML));

			});
		}

	})

})(jQuery);

// Coupon Message
(function($) {
	const checkoutCoupon = document.querySelector('.coupon-container');

	if (checkoutCoupon) {
		$('.coupon-container').each(function() {
			var enableButton = this.querySelector('.checkout-apply');

			$(enableButton).on('click', () => {
				setTimeout(function() {
					$('.woocommerce-message').fadeOut('fast');
					$('.woocommerce-error').fadeOut('fast');
				}, 5000); // <-- time in mseconds
			})
		});
	}
})(jQuery);

// Empty space upsell
(function($) {

	$(document).ready(function() {

		var checkout = document.querySelector(".woocommerce-checkout");

		if (checkout) {
			$('.checkout-upsell-container').each(function() {
				var enableButton = this.querySelector('.cuw-button');

				$(enableButton).on('click', (e) => {
					$(e.target).closest(".checkout-upsell-container").remove();
				})
			});

			document.querySelector('form[name="checkout"]').addEventListener('click', function(e){
				if(document.getElementById('place_order').contains(e.target)) jQuery('.checkout.woocommerce-checkout').find( '.input-text, select, input:checkbox' ).trigger( 'validate' ).trigger( 'blur' );
			})
		}
	})


})(jQuery);

// Sticky items functionality

(function($) {

	// Sticky items scroll

	var home = document.querySelector('.home');

	if (home) {
		var hero = document.querySelector('.hero-home');
		var card = document.querySelector('.home-searcher');
	} else {
		var hero = document.querySelector('.hero');
		var card = document.querySelector('.hero-card');
	}

	var ppcSearch = document.querySelector('.ppc-search-bar');

	var brands = document.querySelector('.brands');

	var search = document.querySelector('.search-block');

	var orderStick = document.querySelector('.order-stick');

	var alphaStick = document.querySelector('.alpha-stick');

	var isDesktop = $(window).width() > 991;
	var isMobile = $(window).width() < 992;

	if (card) {
		var cardTop = $(card).offset().top;
		var cardHeight = $(card).outerHeight();

		var cardContainerTop = $(hero).offset().top;
		var cardContainerHeight = $(hero).outerHeight();

		// Sticky header on desktop scroll

		if (isDesktop) {
			$(window).scroll(function(){
				if($(window).scrollTop() > (cardTop + cardHeight)){
					document.querySelector('.header-sticky').classList.remove('d-none');
				}
				else{
					document.querySelector('.header-sticky').classList.add('d-none');
				}
			});
		}

		else {
			document.querySelector('.header-sticky').classList.add('d-none');
		}

		// Sticky card button on mobile scroll

		if (isMobile) {
			$(window).scroll(function(){
				if($(window).scrollTop() > (cardContainerTop + cardContainerHeight)){
					document.querySelector('.hero-card-sticky').classList.remove('d-none');
				}
				else{
					document.querySelector('.hero-card-sticky').classList.add('d-none');
				}
			});
		}

		else {
			document.querySelector('.hero-card-sticky').classList.add('d-none');
		}

		// Sticky disabling on resize: work on more not doing as intended

		$(window).resize(function () {
			// Sticky header disable
			if (isMobile) {
				document.querySelector('.header-sticky').classList.add('d-none');
			}

			// Sticky card button disable
			if (isDesktop) {
				document.querySelector('.hero-card-sticky').classList.add('d-none');
			}
		});
	}

	if (search) {
		var searchTop = $(search).offset().top;
		var searchHeight = $(search).outerHeight();

		// Sticky header on desktop scroll

		if (isDesktop) {
			$(window).scroll(function(){
				if($(window).scrollTop() > (searchTop + searchHeight)){
					document.querySelector('.header-sticky').classList.remove('d-none');
				}
				else{
					document.querySelector('.header-sticky').classList.add('d-none');
				}
			});
		}

		else {
			document.querySelector('.header-sticky').classList.add('d-none');
		}

		// Sticky card button on mobile scroll

		if (isMobile) {
			$(window).scroll(function(){
				if($(window).scrollTop() > (searchTop + searchHeight)){
					document.querySelector('.hero-card-sticky').classList.remove('d-none');
				}
				else{
					document.querySelector('.hero-card-sticky').classList.add('d-none');
				}
			});
		}

		else {
			document.querySelector('.hero-card-sticky').classList.add('d-none');
		}

		// Sticky disabling on resize: work on more not doing as intended

		$(window).resize(function () {
			// Sticky header disable
			if (isMobile) {
				document.querySelector('.header-sticky').classList.add('d-none');
			}

			// Sticky card button disable
			if (isDesktop) {
				document.querySelector('.hero-card-sticky').classList.add('d-none');
			}
		});
	}

	if (ppcSearch) {
		var ppcSearchTop = $(ppcSearch).offset().top;
		var ppcSearchHeight = $(ppcSearch).outerHeight();

		if (isDesktop) {
			$(window).scroll(function(){
				if($(window).scrollTop() > (ppcSearchTop)){
					document.querySelector('.ppc-search-bar').classList.add('is-sticky');
				}
				else{
					document.querySelector('.ppc-search-bar').classList.remove('is-sticky');
				}
			});
		}

		else {
			document.querySelector('.ppc-search-bar').classList.remove('is-sticky');
		}

		// Sticky card button on mobile scroll

		if (isMobile) {
			$(window).scroll(function(){
				if($(window).scrollTop() > (ppcSearchTop + ppcSearchHeight)){
					document.querySelector('.hero-card-sticky').classList.remove('d-none');
				}
				else{
					document.querySelector('.hero-card-sticky').classList.add('d-none');
				}
			});
		}

		else {
			document.querySelector('.hero-card-sticky').classList.add('d-none');
		}

		// Sticky disabling on resize: work on more not doing as intended

		$(window).resize(function () {
			// Sticky header disable
			if (isMobile) {
				document.querySelector('.ppc-search-bar').classList.remove('is-sticky');
			}

			// Sticky card button disable
			if (isDesktop) {
				document.querySelector('.hero-card-sticky').classList.add('d-none');
			}
		});
	}

	if (brands || orderStick) {
		var navbar = document.querySelector('.navbar');
		var navTop = $(navbar).offset().top;
		var navHeight = $(navbar).outerHeight();

		// Sticky header on desktop scroll

		if (isDesktop) {
			$(window).scroll(function(){
				if($(window).scrollTop() > (navTop + navHeight)){
					document.querySelector('.header-sticky').classList.remove('d-none');
				}
				else{
					document.querySelector('.header-sticky').classList.add('d-none');
				}
			});
		}

		else {
			document.querySelector('.header-sticky').classList.add('d-none');
		}

		// Sticky card button on mobile scroll

		if (isMobile) {
			$(window).scroll(function(){
				if($(window).scrollTop() > (navTop + navHeight)){
					document.querySelector('.hero-card-sticky').classList.remove('d-none');
				}
				else{
					document.querySelector('.hero-card-sticky').classList.add('d-none');
				}
			});
		}

		else {
			document.querySelector('.hero-card-sticky').classList.add('d-none');
		}

		// Sticky disabling on resize: work on more not doing as intended

		$(window).resize(function () {
			// Sticky header disable
			if (isMobile) {
				document.querySelector('.header-sticky').classList.add('d-none');
			}

			// Sticky card button disable
			if (isDesktop) {
				document.querySelector('.hero-card-sticky').classList.add('d-none');
			}
		});
	}

	if (alphaStick) {
		console.log("Found");
		var alphaSelect = document.querySelector('.brand-alpha-select');
		var alphaSelectTop = $(alphaSelect).offset().top;
		var alphaSelectHeight = $(alphaSelect).outerHeight();

		$(window).scroll(function(){
			if($(window).scrollTop() > (alphaSelectTop + alphaSelectHeight)){
				document.querySelector('.alpha-select-sticky').classList.remove('d-none');
			}
			else{
				document.querySelector('.alpha-select-sticky').classList.add('d-none');
			}
		});

		$('.alpha-select').each(function() {
			const $this = $(this);

			$this.on('click', () => {
				const $val = '#' + this.innerHTML;
				document.querySelector($val).scrollIntoView({ behavior: "instant", block: "start" });
			})

		});

		$('.alpha-select-dropdown').change(function () {
			const $val = '#' + $(this).val()
			window.location.hash = $val;
			document.querySelector($val).scrollIntoView({ behavior: "instant", block: "start" });
		});
	}

})(jQuery);

function showColorSearch() {

	// Sticky card button click functionality

	var sticky = document.querySelector('.hero-card-sticky');
	var stickyButton = sticky.querySelector('.btn-sticky');

	var stickyMenu = document.querySelector('.sticky-card-wrapper');
	var stickyClose = stickyMenu.querySelector('.btn-sticky-card-clear');

	var noScrollBehind = document.querySelector('.page');



	if (stickyButton) {
		stickyButton.addEventListener('click', function() {
			stickyMenu.classList.toggle('active');
			document.body.style.overflow = 'hidden';
			noScrollBehind.classList.toggle('disable-scroll');
		});
	}

	if (stickyClose) {
		stickyClose.addEventListener('click', function() {
			stickyMenu.classList.toggle('active');
			document.body.style.overflow = 'auto';
			noScrollBehind.classList.toggle('disable-scroll');
		});
	}

	var mbMenu = document.querySelector('.header-menu-mobile');
	var orderMenuBtn = mbMenu.querySelector('.btn-menu');

	if (orderMenuBtn) {
		orderMenuBtn.addEventListener('click', function() {
			stickyMenu.classList.toggle('active');
			noScrollBehind.classList.toggle('disable-scroll');
		});
	}
}
showColorSearch();
